/** Spanish translations. */
export const es = {
    seo: {
        "landing": {
            "title": "TMC Studio — dibuja cualquier táctica en 30 segundos",
            "description": "Pizarra táctica rapidísima para entrenadores, analistas y creadores. Crea formaciones, anima jugadas y exporta PNG, GIF, PDF o SVG — directamente en el navegador."
        },
        "pricing": {
            "title": "Precios — TMC Studio",
            "description": "Empieza gratis, sin cuenta. Compara los planes Gratis, Pro y Equipo. Pro ofrece proyectos ilimitados y exportación GIF/PDF."
        }
    },
    cookieBanner: {
        "label": "Consentimiento de cookies",
        "message": "Usamos cookies esenciales para que TMC Studio funcione. Con tu consentimiento también usamos cookies analíticas para mejorar el producto.",
        "accept": "Aceptar todas",
        "reject": "Rechazar las no esenciales",
        "policy": "Política de cookies"
    },
    pricingPage: {
        "hero": {
            "title": "Elige cómo quieres usar TMC Studio",
            "subtitle": "Empieza gratis, sin cuenta. Mejora solo cuando llegues a un límite real."
        },
        "billing": {
            "monthly": "Mensual",
            "yearly": "Anual",
            "yearlyHint": "2 meses gratis"
        },
        "plans": {
            "guestName": "Invitado",
            "freeName": "Gratis",
            "proName": "Pro",
            "teamName": "Equipo",
            "guestCta": "Abrir la pizarra",
            "freeCta": "Continuar gratis",
            "proCta": "Pasar a Pro",
            "teamCta": "Pasar a Equipo",
            "perMonth": "/mes",
            "perYear": "/año",
            "free": "Gratis",
            "guestTagline": "Sin cuenta",
            "freeTagline": "Gratis para siempre tras registrarte",
            "proTagline": "Para entrenadores y creadores",
            "teamTagline": "Para clubes y cuerpo técnico"
        },
        "matrix": {
            "feature": "Función",
            "projects": "Proyectos",
            "steps": "Pasos por proyecto",
            "folders": "Carpetas",
            "cloudSync": "Sincronización en la nube",
            "exportPng": "Exportar PNG / JPG",
            "exportGif": "Exportar GIF",
            "exportPdf": "Exportar PDF",
            "seats": "Plazas",
            "invite": "Invitar miembros",
            "unlimited": "Ilimitado"
        },
        "vatNote": "Los precios para consumidores de la UE incluyen IVA. Las empresas con un número de IVA intracomunitario válido se facturan con inversión del sujeto pasivo.",
        "faq": {
            "title": "Preguntas sobre facturación",
            "q1": "¿Gratis es realmente gratis?",
            "a1": "Sí. No es una prueba: sigue siendo gratis para siempre tras crear una cuenta. Sin tarjeta.",
            "q2": "¿Puedo cancelar cuando quiera?",
            "a2": "Sí. Gestiona o cancela tu suscripción cuando quieras desde tu cuenta; conservas Pro hasta el final del periodo facturado.",
            "q3": "¿Cómo funcionan los reembolsos?",
            "a3": "Las suscripciones digitales se rigen por nuestra política de reembolsos y los derechos del consumidor de la UE. Más detalles en la página de Reembolsos.",
            "q4": "¿Hay facturación anual?",
            "a4": "Sí. La facturación anual te da dos meses gratis frente al pago mensual."
        },
        "teamCalc": {
            "title": "Perfecto para clubes y cuerpo técnico",
            "subtitle": "Team ofrece a cada entrenador su propio espacio de trabajo con facturación compartida — por una fracción del costo de suscripciones Pro separadas.",
            "fivePro": "5 × suscripciones Pro",
            "teamPlan": "Plan Team",
            "savings": "Ahorra {{amount}}{{period}}",
            "cta": "Elegir Team"
        }
    },
    landing: {
        "nav": {
            "features": "Funciones",
            "pricing": "Precios",
            "download": "Descargar",
            "openBoard": "Abrir la pizarra"
        },
        "hero": {
            "titlePre": "Dibuja cualquier táctica en ",
            "titleHighlight": "30 segundos",
            "subtitle": "Pizarra táctica rapidísima para entrenadores, analistas y creadores. Ábrela en el navegador y empieza a dibujar: sin instalación y sin registro.",
            "trustLine": "Sin cuenta · Gratis · Funciona en el navegador",
            "ctaPrimary": "Abrir la pizarra — sin registro",
            "ctaSecondary": "Ver planes",
            "demoAlt": "Demostración animada de creación de una táctica",
            "badge": "Funciona en el navegador — sin instalación"
        },
        "credibility": {
            "title": "Todo lo que necesitas, al instante",
            "item1Metric": "30 s",
            "item1Label": "hasta tu primera táctica lista",
            "item2Metric": "4 formatos",
            "item2Label": "exporta PNG · GIF · PDF · SVG",
            "item3Metric": "0 €",
            "item3Label": "empieza sin cuenta ni tarjeta"
        },
        "how": {
            "title": "De la idea a la táctica en 30 segundos",
            "s1Title": "Elige una formación",
            "s1Desc": "Pulsa 1–6 para colocar al instante una formación completa en el campo.",
            "s2Title": "Añade movimiento",
            "s2Desc": "Dibuja pases y desmarques con A y R, directamente desde el teclado.",
            "s3Title": "Exporta y comparte",
            "s3Desc": "Pulsa Cmd+E para una imagen, o exporta un GIF animado o un PDF."
        },
        "pillars": {
            "title": "Diseñada para la velocidad",
            "speedTitle": "Rápida",
            "speedDesc": "Del campo en blanco a la táctica terminada en un momento.",
            "stepsTitle": "Mínimos pasos",
            "stepsDesc": "Sin rebuscar en menús. Un atajo para todo y una paleta de comandos.",
            "everywhereTitle": "Sin instalación",
            "everywhereDesc": "Funciona en cualquier navegador moderno — Chrome, Safari, Firefox, Edge. Nada que descargar.",
            "shareTitle": "Listo para compartir",
            "shareDesc": "Exporta PNG, GIF, PDF o SVG con una sola tecla."
        },
        "workflow": {
            "eyebrow": "Una biblioteca para el entrenador",
            "title": "De una idea en el campo a una sesión completa",
            "desc": "No te quedes en una imagen. Guarda el gráfico, conviértelo en un ejercicio reutilizable y añádelo a una sesión completa con tiempos, plantilla, cuerpo técnico y material.",
            "graphicTitle": "1. Gráfico",
            "graphicDesc": "Dibuja la organización, los movimientos y las zonas clave en una pizarra táctica rápida.",
            "exerciseTitle": "2. Ejercicio",
            "exerciseDesc": "Añade objetivo, organización, duración, jugadores, puntos de entrenamiento y progresión.",
            "sessionTitle": "3. Sesión",
            "sessionDesc": "Ordena los ejercicios, asigna cuerpo técnico y plantilla, y descarga el PDF o imprime.",
            "presetTitle": "4. Alineaciones guardadas",
            "presetDesc": "Guarda bloque bajo, bloque medio y presión. Cárgalos desde el banquillo o con Option/Alt+1–9.",
            "cta": "Crear una sesión"
        },
        "keyboard": {
            "title": "Primero el teclado, el ratón es opcional",
            "desc": "Cada acción tiene un atajo, así tus manos no dejan las teclas.",
            "palette": "Pulsa Cmd+K para la paleta de comandos."
        },
        "everywhere": {
            "title": "En cada dispositivo",
            "desc": "Usa TMC Studio en cualquier navegador, o instala la app de escritorio para macOS y Windows. Todo se sincroniza con tu cuenta.",
            "cta": "Abrir la pizarra"
        },
        "useCases": {
            "title": "Hecha para tu flujo de trabajo",
            "coachesTitle": "Entrenadores y analistas",
            "coachesDesc": "Prepara sesiones y charlas de partido, luego imprime o exporta a PDF.",
            "creatorsTitle": "Creadores de contenido",
            "creatorsDesc": "Convierte ideas en GIFs animados para compartir en menos de un minuto.",
            "clubsTitle": "Clubes y cuerpo técnico",
            "clubsDesc": "Exporta las charlas a PDF y entrégalas a todo tu cuerpo técnico — un plan coherente para todos."
        },
        "pricingTeaser": {
            "title": "Lo gratis es gratis para siempre",
            "desc": "Empieza gratis, sin cuenta. Pasa a Pro cuando necesites proyectos ilimitados y exportación GIF/PDF.",
            "cta": "Comparar planes",
            "free": "Gratis",
            "pro": "Pro"
        },
        "spotlight": {
            "title": "Hecho para tu forma de trabajar",
            "kbTitle": "Primero el teclado. Todo tiene un atajo.",
            "kbDesc": "Pulsa Cmd+K para abrir la paleta de comandos, o A para flechas, P para jugadores, N para nuevos pasos. Tus manos nunca dejan el teclado: arrastra, redimensiona y edita sin tocar menús.",
            "stepsTitle": "Exporta puntos de debate, no capturas.",
            "stepsDesc": "Construye tácticas paso a paso, luego exporta la secuencia completa como GIF animado o PDF multipágina. Los entrenadores lo usan para charlas, los creadores lo convierten en contenido social.",
            "syncTitle": "Abre un enlace. Empieza a dibujar.",
            "syncDesc": "Sin instalación ni cuenta para empezar. El modo Invitado te deja dibujar al instante, y una cuenta gratis guarda tus proyectos en la nube."
        },
        "faq": {
            "title": "Preguntas frecuentes",
            "q1": "¿Es realmente gratis?",
            "a1": "Sí. El modo Invitado no requiere cuenta ni tarjeta. Una cuenta gratuita incluye tres gráficos, ejercicios y planes de sesión de cada tipo con sincronización en la nube.",
            "q2": "¿Qué puedo hacer como Invitado?",
            "a2": "Empieza a dibujar inmediatamente — sin cuenta, sin registro. Tienes 1 proyecto con 5 pasos y exportación PNG. ¿Listo para guardar? Crea una cuenta gratis con un clic.",
            "q3": "¿Necesito descargar algo?",
            "a3": "No. TMC Studio funciona en cualquier navegador moderno: Chrome, Safari, Firefox, Edge. Solo ábrelo y dibuja, nada que descargar.",
            "q4": "¿Qué formatos de exportación hay?",
            "a4": "Invitado y Gratis: PNG y JPG. Pro añade animaciones GIF y PDF con todos los pasos. Cada formato está a un clic o un atajo de distancia.",
            "q5": "¿Cómo funciona la facturación de Pro?",
            "a5": "Pro cuesta \$9/mes o \$90/año (ahorra 17%). Cancela cuando quieras — el acceso continúa hasta el final del periodo facturado. Los precios incluyen IVA para clientes de la UE.",
            "q6": "¿Puede usarlo todo mi equipo técnico?",
            "a6": "Sí. Team ofrece 5 plazas con espacios de trabajo individuales y facturación compartida. Cada entrenador gestiona sus pizarras y tú recibes una sola factura.",
            "q7": "¿Puedo guardar varias alineaciones?",
            "a7": "Sí. Guarda hasta 50 alineaciones con nombre, como bloque bajo o presión 4-3-3. Cárgalas desde el banquillo o con Option/Alt+1–9 y edítalas en el campo.",
            "q8": "¿TMC Studio crea sesiones completas?",
            "a8": "Sí. Combina un gráfico con detalles, series y descansos, y crea una sesión con plantilla, cuerpo técnico y ejercicios ordenados. Imprime o descarga el PDF."
        },
        "finalCta": {
            "title": "Empieza a dibujar en 30 segundos.",
            "desc": "Sin cuenta, sin descarga, sin tarjeta. Solo tú y el campo.",
            "cta": "Abrir la pizarra — sin registro"
        },
        "footer": {
            "tagline": "Pizarra táctica de fútbol, rápida y profesional.",
            "rights": "Todos los derechos reservados.",
            "legalNotice": "Aviso legal",
            "refunds": "Reembolsos",
            "accessibility": "Accesibilidad"
        }
    },
    changelog: { title: 'Novedades', description: 'Una historia clara de cómo mejoramos TMC Studio junto con la comunidad de entrenadores.', current: 'Versión actual del producto: {{version}}', sections: { new: 'Novedades', improved: 'Mejoras', fixed: 'Corregido' }, releases: {
            v013: { summary: 'Esta versión completa el trabajo diario del entrenador con alineaciones rápidas, el flujo de gráfico a sesión y una comunicación más directa.', lineups: 'Alineaciones con nombre, selección rápida y atajos adaptados a macOS y Windows.', feedback: 'El changelog público y el formulario de errores permiten seguir el progreso y mejorar el producto juntos.', library: 'Simplificamos Gráfico → Ejercicio → Sesión con vistas previas, intervalos y exportación PDF.', responsive: 'El banquillo, los menús, la biblioteca y los espacios de trabajo se adaptan mejor a pantallas pequeñas.', returnFlow: 'La edición de la plantilla vuelve exactamente al punto de inicio: Ajustes o el campo.', presetMenu: 'El editor rápido de alineaciones ya no sale del área de trabajo.' },
            v012: { summary: 'Nos centramos en planificar entrenamientos y gestionar plantillas grandes con menos trabajo repetitivo.', sessions: 'Las sesiones incluyen fechas, nombres y selección de plantilla predeterminados.', intervals: 'Los ejercicios admiten series, tiempo de trabajo y descansos.', bulk: 'La biblioteca permite selección múltiple, borrado masivo y organización más rápida.', roster: 'La importación admite 35 jugadores por equipo y conserva dorsales repetidos.', pdf: 'Corregimos las exportaciones PDF vacías de ejercicios y sesiones.', navigation: 'Al volver del editor se abre ahora la vista correcta de la biblioteca.' },
            v011: { summary: 'El primer gran paso desde una pizarra táctica hacia un entorno completo para preparar entrenamientos.', workflow: 'Creamos bibliotecas separadas para gráficos, ejercicios y sesiones.', seo: 'Añadimos páginas de producto multilingües e indexables.', oauth: 'Mejoramos el acceso con Google mediante un flujo PKCE seguro.', pdf: 'Corregimos la impresión y exportación de ejercicios y sesiones.', authCallback: 'Eliminamos la pantalla bloqueada al volver de la autorización de Google.' }
        } },
    bugReport: { title: 'Reportar un error', description: 'Describe un problema de TMC Studio y ayúdanos a mejorar.', community: 'TMC Studio crece con la comunidad de entrenadores. Cada reporte claro nos ayuda a mejorar más rápido para todos.', titleLabel: 'Título breve', descriptionLabel: '¿Qué ocurrió?', stepsLabel: '¿Cómo reproducirlo?', expectedLabel: '¿Cómo debería funcionar?', emailLabel: 'Email de respuesta (opcional)', submit: 'Enviar reporte', sending: 'Enviando…', sentTitle: 'Gracias por el reporte', sentBody: 'El equipo de TMC Studio recibió tu reporte. Gracias por ayudarnos a mejorar.', error: 'No se pudo enviar. Inténtalo de nuevo o escribe a support@tacticsmadeclear.store.' },
    common: {
        close: 'Cerrar',
        saving: 'Guardando…',
        loading: 'Cargando…',
        language: 'Idioma',
        settings: 'Ajustes',
    },
    topbar: {
        pitch: 'Campo',
        pitchTitle: 'Ajustes del campo',
        export: 'Exportar',
        focusMode: 'Modo enfoque',
        themeToDark: 'Cambiar a modo oscuro',
        themeToLight: 'Cambiar a modo claro',
        help: 'Ayuda y atajos',
        commandPalette: 'Paleta de comandos',
        openProjects: 'Abrir proyectos',
        projectName: 'Nombre del proyecto',
        clickRename: 'Haz clic para renombrar',
        offline: 'Offline',
        saving: 'Guardando…',
        saved: 'Guardado',
        unsaved: 'Sin guardar',
        players: 'Jugadores',
        addPlayers: 'Añadir jugadores',
        arrows: 'Flechas',
        showArrows: 'Mostrar flechas',
        zones: 'Zonas',
        showZones: 'Mostrar zonas',
        equipment: 'Equipamiento',
        showEquipment: 'Mostrar equipamiento',
        exportBoard: 'Exportar pizarra',
        presetSquad: 'Preparar plantilla',
        squadHint: 'Arrastra fácilmente al campo',
        rectangleZone: 'Zona rectangular',
        polygonZone: 'Zona poligonal',
        tallCone: 'Cono alto',
        ballCluster: 'Grupo de balones',
        exportPngCurrent: 'PNG — paso actual',
        exportPngAll: 'PNG — todos los pasos',
        exportJpgCurrent: 'JPG — paso actual',
        exportPdfAll: 'PDF — todos los pasos',
        exportGif: 'GIF animado',
        proMarked: 'Funciones Pro marcadas con ⭐',
        account: 'Cuenta',
        planPro: 'Pro',
        planFree: 'Free',
        accountBilling: 'Cuenta y facturación',
        accountEditorOptions: 'Opciones del editor',
        accountPitchSettings: 'Ajustes del campo',
        accountSquadSettings: 'Ajustes del equipo',
        accountYourProfile: 'Tu perfil',
        signInToSave: 'Inicia sesión — guarda proyectos gratis',
        signInToSaveDesc: 'Crea una cuenta gratis para guardar, sincronizar y gestionar tus pizarras en todos tus dispositivos.',
        upgradePro: 'Mejorar a Pro',
        devTestLogin: 'Inicio dev de prueba',
        devGuest: 'Guest',
        devFree: 'Bez Premium',
        devSolo: 'Solo',
        devTeam: 'Team',
        clearDevData: 'Borrar datos de prueba',
        logOut: 'Cerrar sesión',
        toggleInspector: 'Alternar inspector',
        signIn: 'Iniciar sesión',
        signInDescription: 'Inicia sesión para guardar y sincronizar tus pizarras',
    },
    contextMenu: {
        header: {
            player: 'Jugador #{{number}} ({{team}})',
            zone: 'Zona ({{shape}})',
            text: 'Texto: "{{preview}}"',
            arrow: 'Flecha {{type}}',
            ball: 'Balón',
            equipment: '{{type}}',
        },
        arrow: {
            pass: 'Pase',
            run: 'Carrera',
            shoot: 'Tiro',
            dribble: 'Regate',
        },
        shape: {
            rectangle: 'Rectángulo',
            ellipse: 'Elipse',
            polygon: 'Polígono',
        },
        selectedCount: '{{count}} elementos seleccionados',
        groupSelected: 'Agrupar seleccionados',
        ungroup: 'Desagrupar',
        lockElement: 'Bloquear elemento',
        unlockElement: 'Desbloquear elemento',
        lockSelected: 'Bloquear seleccionados',
        unlockSelected: 'Desbloquear seleccionados',
        copy: 'Copiar',
        paste: 'Pegar',
        selectAll: 'Seleccionar todo',
        duplicate: 'Duplicar',
        delete: 'Eliminar',
        resize: 'Redimensionar…',
        addPlayerTeam1: 'Añadir jugador Equipo 1',
        addPlayerTeam2: 'Añadir jugador Equipo 2',
        addPlayerTeam3: 'Añadir jugador Equipo 3',
        addPlayerTeam4: 'Añadir jugador Equipo 4',
        addBall: 'Añadir balón',
        addArrow: 'Añadir flecha',
        addZone: 'Añadir zona',
        autoNumberingOn: 'Auto-numeración: ON',
        autoNumberingOff: 'Auto-numeración: OFF',
        changeNumber: 'Cambiar número',
        renumberArrows: 'Renumerar desde 1',
        switchTeam: 'Cambiar equipo',
        cycleShape: 'Cambiar forma',
        changeColor: 'Cambiar color',
        editText: 'Editar texto',
        alignLeft: 'Alinear a la izquierda',
        alignCenter: 'Centrar',
        alignRight: 'Alinear a la derecha',
        alignJustify: 'Justificar',
        editArrowNumber: 'Editar número de flecha',
        rotate: 'Rotar',
        bringToFront: 'Traer al frente',
        bringForward: 'Traer adelante',
        sendBackward: 'Enviar atrás',
        sendToBack: 'Enviar al fondo',
    },
    footer: {
        label: 'Pie',
        download: 'Descargar app',
        privacy: 'Privacidad',
        terms: 'Términos',
        cookies: 'Cookies',
        contact: 'Contacto',
        changelog: 'Novedades',
        reportBug: 'Reportar un error',
        hide: 'Ocultar pie',
        show: 'Mostrar pie',
        social: {
            x: 'Perfil de X',
            linkedin: 'Perfil de LinkedIn',
            github: 'Perfil de GitHub',
        },
    },
    legacy: {
        toolbar: {
            newBoard: 'Nueva pizarra',
            new: 'Nueva',
            saveTitle: 'Guardar (Ctrl+S)',
            save: 'Guardar',
            load: 'Cargar',
            addHomePlayer: 'Añadir jugador local (P)',
            home: 'Local',
            addAwayPlayer: 'Añadir jugador visitante',
            away: 'Visitante',
            addBall: 'Añadir balón (B)',
            ball: 'Balón',
            duplicateTitle: 'Duplicar (Ctrl+D)',
            duplicate: 'Duplicar',
            deleteTitle: 'Eliminar (Del)',
            delete: 'Eliminar',
            undo: 'Deshacer (Ctrl+Z)',
            redo: 'Rehacer (Ctrl+Shift+Z)',
            hint: 'P: jugador | B: balón | Ctrl+D: duplicar | Ctrl+Z: deshacer',
        },
        rightPanel: {
            properties: 'Propiedades',
            none: 'No hay elemento seleccionado',
            noneHint: 'Haz clic en un jugador o balón para ver sus propiedades',
            selected: '{{count}} elementos seleccionados',
            multiHint: 'Modo de selección múltiple. Usa Ctrl+D para duplicar o Delete para eliminar.',
            type: 'Tipo',
            homePlayer: 'Jugador local',
            awayPlayer: 'Jugador visitante',
            ball: 'Balón',
            number: 'Número',
            label: 'Etiqueta (opcional)',
            labelPlaceholder: 'p. ej. Messi',
            position: 'Posición',
            shortcuts: 'Atajos',
            shiftClick: 'Shift + clic = selección múltiple',
            delDelete: 'Del = eliminar selección',
        },
    },
    zoom: {
        out: 'Alejar (Cmd -)',
        outAria: 'Alejar',
        in: 'Acercar (Cmd +)',
        inAria: 'Acercar',
        value: 'Zoom: {{percent}}%',
        unlock: 'Desbloquear vista (activar zoom/pan)',
        lock: 'Bloquear vista (evitar zoom/pan)',
        unlockAria: 'Desbloquear viewport',
        lockAria: 'Bloquear viewport',
        fit: 'Ajustar',
        fitTitle: 'Ajustar a la vista (Shift+1)',
        fitAria: 'Ajustar a la vista',
    },
    offline: {
        message: 'Estás offline — los cambios se sincronizarán al volver online',
    },
    textEdit: {
        hint: 'Enter para guardar · Shift+Enter para nueva línea',
    },
    shortcutsHint: {
        press: 'Pulsa',
        forShortcuts: 'para atajos',
        forCommands: 'para comandos',
    },
    bottomSheet: {
        inspectorPanel: 'Panel inspector',
        closeInspector: 'Cerrar inspector',
        close: 'Cerrar',
    },
    smartBottom: {
        undo: 'Deshacer (⌘Z)',
        redo: 'Rehacer (⇧⌘Z)',
        resize: 'Arrastra para cambiar la altura',
        collapse: 'Contraer barra',
        expand: 'Expandir barra',
        addPlayer: 'Añadir jugador',
        addBall: 'Añadir balón',
        drawArrow: 'Dibujar flecha',
        allCommands: '⌘K — todos los comandos',
        elements: '{{count}} elemento(s)',
        editing: 'Editando',
    },
    inspector: {
        props: 'Propiedades',
        layers: 'Capas',
        identity: 'Identidad',
        appearance: 'Apariencia',
        labels: 'Etiquetas',
        role: 'Rol',
        advanced: 'Avanzado',
        numbering: 'Numeración',
        sequence: 'Secuencia',
        number: 'Número',
        label: 'Etiqueta',
        showLabelBelow: 'Mostrar etiqueta debajo',
        goalkeeper: 'Portero',
        gkHint: 'Usa el color de portero del equipo · Shift+G',
        labelSize: 'Tamaño de etiqueta',
        opacity: 'Opacidad',
        opacityAll: 'Opacidad (todo)',
        playerLabelPlaceholder: 'Apellido o apodo…',
        playerLabelAria: 'Etiqueta del jugador',
        showOrientation: 'Mostrar orientación',
        showArms: 'Mostrar brazos',
        visionCone: 'Cono de visión',
        zoomThreshold: 'Umbral de zoom',
        showNumber: 'Mostrar número',
        autoNumber: 'Autonumerar flechas',
        renumber: 'Renumerar 1…N',
        showLabelBelowAria: 'Mostrar etiqueta debajo',
        goalkeeperAria: 'Portero',
        showOrientationAria: 'Mostrar orientación',
        showArmsAria: 'Mostrar brazos',
        visionConeAria: 'Cono de visión',
        showNumberAria: 'Mostrar número',
        autoNumberAria: 'Autonumerar flechas',
        arrowNumberPlaceholder: 'Sin número',
        arrowNumberAria: 'Número de flecha',
        renumberAria: 'Renumerar flechas',
        groups: 'Grupos',
        doubleClickRename: 'Doble clic para renombrar',
        unlockGroup: 'Desbloquear grupo',
        lockGroup: 'Bloquear grupo',
        hideGroup: 'Ocultar grupo',
        showGroup: 'Mostrar grupo',
        locked: 'Bloqueo',
        lockToggle: 'Bloquear elemento',
        lockHint: 'Los elementos bloqueados permanecen seleccionados, pero no se pueden mover ni redimensionar.',
        visionConeHint: 'V / Mayús+V',
        selected: '{{count}} elementos seleccionados',
        multiHint: 'Se aplica a los jugadores seleccionados.',
        showLabels: 'Mostrar etiquetas',
        hideLabels: 'Ocultar etiquetas',
        searchPlaceholder: 'Buscar elementos…',
        noElements: 'No se encontraron elementos',
        quickActions: 'Acciones rápidas',
        commandPalette: 'Paleta de comandos',
        closeInspector: 'Cerrar inspector (I)',
        closeInspectorAria: 'Cerrar inspector',
        resize: 'Arrastra para cambiar el ancho del panel',
        openInspector: 'Abrir inspector (I)',
        openInspectorAria: 'Abrir inspector',
        openInspectorPanelAria: 'Abrir panel del inspector',
        inspectorTitle: 'Inspector (I)',
        showCoordinates: 'Mostrar coordenadas',
        elementType: {
            player: 'Jugador', ball: 'Balón', arrow: 'Flecha', zone: 'Zona', text: 'Texto',
        },
        team: {
            home: 'Local', away: 'Visitante', team3: 'Equipo 3', team4: 'Equipo 4',
        },
        setAsDefault: 'Fijar como predeterminado', setAsDefaultHint: 'Guarda el aspecto actual como predeterminado para nuevos elementos', setAsDefaultDone: 'Guardado como predeterminado',
        zone: {
            border: 'Límite', borderStyle: 'Estilo', solid: 'Sólido', dashed: 'Discontinuo', none: 'Ninguno',
            borderWidth: 'Grosor', borderColor: 'Color', corners: 'Esquinas',
        },
        arrow: {
            head: 'Flecha', startHead: 'Inicio', endHead: 'Final',
            line: 'Línea', thickness: 'Grosor', color: 'Color',
            headArrow: 'Flecha', headNone: 'Ninguno', headBar: 'Barra', headDot: 'Punto',
            doubleHead: 'Doble punta', hideHeads: 'Ocultar puntas',
        },
        filters: {
            all: 'Todos', home: 'Local', away: 'Visitante', ball: 'Balón',
        },
        layerNames: {
            homePlayers: 'Local', awayPlayers: 'Visitante', ball: 'Balón',
            arrows: 'Flechas', zones: 'Zonas', labels: 'Texto y etiquetas',
            equipment: 'Equipamiento', drawings: 'Dibujos',
        },
    },
    settings: {
        account: 'Cuenta', club: 'Club y miembros', editor: 'Editor', board: 'Campo', general: 'General',
        profile: 'Perfil', security: 'Seguridad', billing: 'Facturación', preferences: 'Preferencias', squad: 'Plantilla', teams: 'Equipos', pitch: 'Campo', shortcuts: 'Atajos', dataPrivacy: 'Datos y privacidad', about: 'Acerca de',
        close: 'Cerrar ajustes', profileInfo: 'Información del perfil', profilePhoto: 'Foto de perfil', uploading: 'Subiendo…', uploadPhoto: 'Subir nueva foto', fullName: 'Nombre completo', yourName: 'Tu nombre', emailReadonly: 'El email no se puede cambiar',
        saving: 'Guardando…', saveChanges: 'Guardar cambios', changePassword: 'Cambiar contraseña', currentPassword: 'Contraseña actual', currentPasswordPlaceholder: 'Introduce la contraseña actual', newPassword: 'Nueva contraseña', newPasswordPlaceholder: 'Introduce nueva contraseña (mín. 8 caracteres)', confirmNewPassword: 'Confirmar nueva contraseña', confirmNewPasswordPlaceholder: 'Confirma la nueva contraseña', changing: 'Cambiando…',
        dangerZone: 'Zona de riesgo', deleteAccount: 'Eliminar cuenta', deleteWarning: 'Esta acción no se puede deshacer. Eliminaremos tu cuenta, proyectos, archivos y club, y se cancelará cualquier suscripción.', typeDelete: 'Escribe DELETE para confirmar', enterPassword: 'Introduce tu contraseña', yourPassword: 'Tu contraseña', deleting: 'Eliminando…', deleteMyAccount: 'Eliminar mi cuenta',
        currentPlan: 'Plan actual', plan: 'Plan', upgrade: 'Mejorar', renewsOn: 'Se renueva el {{date}}', freeNudgeTitle: 'Estás en Free — mejora a Pro para más', freeNudgeText: 'Obtén proyectos ilimitados, pasos ilimitados, exportación GIF/PDF y soporte prioritario', upgradeProArrow: 'Mejorar a Pro →', manageSubscription: 'Gestionar suscripción', openBillingPortal: 'Abrir portal de facturación', billingPortalHint: 'Actualiza método de pago, mira facturas o cancela la suscripción',
        appearance: 'Apariencia', theme: 'Tema', light: 'Claro', dark: 'Oscuro', system: 'Sistema', showGrid: 'Mostrar cuadrícula', showGridHint: 'Muestra la cuadrícula de alineación en el canvas', snapGrid: 'Ajustar a cuadrícula', snapGridHint: 'Alinea elementos automáticamente a la cuadrícula', gridDensity: 'Densidad de cuadrícula', gridDensityHint: 'Controla el espaciado visible de la cuadrícula y el ajuste de elementos nuevos o movidos.', pixelsValue: '{{value}}px', editorDefaults: 'Valores predeterminados del editor', defaultArrow: 'Flecha predeterminada', defaultArrowHint: 'Se usa en botones genéricos de Añadir flecha en estados vacíos y barras rápidas.', arrowPass: 'Pase', arrowRun: 'Carrera', arrowShoot: 'Tiro', arrowDribble: 'Regate', defaultStepDuration: 'Duración predeterminada del paso', defaultStepDurationHint: 'Se usa para el ritmo de reproducción y exportación animada.', secondsValue: '{{value}}s', styleDefaults: 'Estilos predeterminados', resetDefaults: 'Restablecer', arrowDefaults: 'Flechas', zoneDefaults: 'Zonas', zoneFill: 'Relleno', zoneOpacity: 'Opacidad', preferencesHint: 'Las preferencias se sincronizan entre dispositivos mediante la nube.', coachingProfile: 'Perfil técnico', coachingProfileHint: 'Datos del club y del cuerpo técnico usados en los planes.', clubLogo: 'Escudo del club', changeLogo: 'Cambiar escudo', clubName: 'Nombre del club', clubNamePlaceholder: 'p. ej. TMC Academy', logoHint: 'El escudo aparece en los planes. PNG, JPG o WebP hasta 1 MB.', staffPresets: 'Tu cuerpo técnico', staffPresetsHint: 'Añade técnicos al plan con un clic.', staffRoleFallback: 'Cuerpo técnico', removeStaff: 'Eliminar a {{name}} del cuerpo técnico', staffName: 'Nombre completo', staffRole: 'Rol, p. ej. asistente', addStaff: 'Añadir', sessionDefaults: 'Valores de nueva sesión', sessionDefaultsHint: 'Define una vez la fecha, el nombre y el lugar de cada nuevo plan.', sessionDateOffset: 'Días desde hoy', sessionNameTemplate: 'Plantilla de nombre', sessionNameTemplatePlaceholder: 'Entrenamiento - {date}', sessionVenue: 'Lugar', sessionStartTime: 'Hora', sessionMicrocycleDay: 'Día del microciclo', positionGroups: 'Grupos de jugadores', positionGroupsHint: 'Asigna jugadores a grupos añadidos automáticamente a cada sesión.', positionGroupPlaceholder: 'p. ej. Centrocampistas', addPositionGroup: 'Añadir grupo', removePositionGroup: 'Eliminar grupo {{name}}', positionGroupsEmptySquad: 'Añade jugadores en la pestaña Plantilla primero.', teamColors: 'Colores de equipos',
        squadRoster: 'Plantilla', playersCount: '{{count}}/{{max}} jugadores', showOnBoard: 'Mostrar en campo', showSquadOnBoard: 'Mostrar plantilla en el campo', proFeature: 'Función Pro', squadFreeHint: 'El plan Free permite hasta 5 jugadores. Pro y Club Premium permiten hasta 35 por equipo (máx. 140).', squadFull: 'El equipo seleccionado está lleno. Pro y Club Premium permiten 35 jugadores por equipo.', name: 'Nombre', playerName: 'Nombre del jugador', numberShort: '#', numberPlaceholder: 'N.º', team: 'Equipo', add: 'Añadir', addMany: 'Añadir varios', addPlayers: 'Añadir jugadores', bulkPlayersLabel: 'Pega una lista de jugadores', bulkPlayersPlaceholder: '1 Juan García\n7, Pedro López\nAdán Verde', bulkPlayersHint: 'Un jugador por línea. Los números indicados, incluidos los repetidos, se conservan; si falta, se asigna el primero libre.', bulkNoValidPlayers: 'No se encontraron jugadores válidos.', bulkSkippedLines: 'Se omitieron líneas con nombre o número inválido: {{lines}}', editPlayerName: 'Editar nombre de {{name}}', editPlayerNumber: 'Editar número de {{name}}', editPlayerTeam: 'Editar equipo de {{name}}', noPlayers: 'Aún no hay jugadores definidos. Añade tu plantilla arriba.', removePlayer: 'Eliminar {{name}}', squadTip: 'Los cambios se guardan automáticamente. Activa “Mostrar en campo” para arrastrar jugadores desde el banquillo.',
        languageHint: 'Elige el idioma de la aplicación.', keyboardShortcuts: 'Atajos de teclado', shortcutCustomizationHint: 'Los atajos están agrupados por flujo del editor. Pro y Club Pro pueden hacer clic en un atajo y grabar una combinación propia.', resetShortcuts: 'Restablecer fábrica', shortcutResetSuccess: 'Atajos restaurados al diseño de fábrica.', shortcutPressKeys: 'Pulsa teclas', shortcutSaved: 'Atajo guardado: {{shortcut}}', shortcutDuplicate: '{{shortcut}} ya está asignado a: {{action}}', shortcutProOnly: 'La edición de atajos está disponible en Pro y Club Pro.', editShortcutAria: 'Editar atajo: {{action}}', aboutVersion: 'Versión {{version}} — Tactics Made Clear', aboutBy: 'by Sportpredictor', contact: 'Contacto', reportBug: 'Reportar error', sendFeedback: 'Enviar feedback', contactFounder: 'Krystian Rubajczyk', contactFounderHint: 'Contacto de producto y reportes rápidos por email o X.', legalPrivacy: 'Privacidad', legalTerms: 'Términos', legalCookies: 'Cookies', legalInfo: 'Información legal', rights: 'Todos los derechos reservados.', dataHint: 'Exporta tu pizarra a un archivo o importa uno guardado antes.', exportBoard: 'Exportar pizarra (.json)', importBoard: 'Importar pizarra', importSuccess: 'Pizarra importada correctamente.', importInvalid: 'Archivo de pizarra no válido.', manualSaveSuccess: 'Proyecto guardado.', manualSaveError: 'No se pudo guardar el proyecto en la nube. Inténtalo de nuevo.', importWarning: 'Importar reemplaza la pizarra actual — exporta primero si quieres conservarla.',
        errors: { nameRequired: 'El nombre es obligatorio', profileFailed: 'No se pudo actualizar el perfil', passwordFields: 'Rellena todos los campos de contraseña', passwordLength: 'La nueva contraseña debe tener al menos 8 caracteres', passwordsMismatch: 'Las contraseñas no coinciden', passwordFailed: 'No se pudo cambiar la contraseña', typeDelete: 'Escribe DELETE para confirmar', passwordRequired: 'La contraseña es obligatoria', deleteFailed: 'No se pudo eliminar la cuenta', ownsClubWithMembers: 'Eres propietario de un club con otros miembros. Transfiere la propiedad o elimina a los miembros y después elimina tu cuenta.', imageFile: 'Selecciona un archivo de imagen', imageSize: 'La imagen debe pesar menos de 2 MB', avatarFailed: 'No se pudo subir el avatar' },
        success: { profile: 'Perfil actualizado.', password: 'Contraseña cambiada.', avatar: 'Avatar actualizado.' },
        shortcutGroups: { create: 'Crear elementos', players: 'Jugadores y orientación', selection: 'Selección', workflow: 'Workflow' },
        shortcutItems: { players: 'Añadir jugador local / visitante', playersHome: 'Añadir jugador local', playersAway: 'Añadir jugador visitante', ball: 'Añadir balón', arrows: 'Flecha de pase / carrera / tiro / regate', passArrow: 'Flecha de pase', runArrow: 'Flecha de carrera', shootArrow: 'Flecha de tiro', dribbleArrow: 'Flecha de regate', zones: 'Zona rectangular / elíptica', zoneRect: 'Zona rectangular', zoneEllipse: 'Zona elíptica', text: 'Etiqueta de texto', equipment: 'Cono / aro', cone: 'Cono', hoop: 'Aro', goalkeeper: 'Asignar portero / cambiar color GK', vision: 'Activar visión para jugadores seleccionados', orientationHandles: 'Alternar controles de orientación', resetOrientation: 'Restablecer orientación seleccionada', formations: 'Aplicar formación local / visitante', focus: 'Modo enfoque', fullShortcuts: 'Abrir atajos completos', resizeUp: 'Aumentar elementos seleccionados', resizeDown: 'Reducir elementos seleccionados' },
        savedLineups: 'Biblioteca de alineaciones tácticas', savedLineupsHint: 'Coloca los jugadores en el campo, nombra la organización y asigna atajos {{shortcuts}}.', lineupNamePlaceholder: 'p. ej. Bloque bajo, Bloque medio, Presión 4-3-3', lineupTeam: 'Equipo de la alineación', saveCurrentLineup: 'Guardar posiciones actuales', noSavedLineups: 'Todavía no hay alineaciones guardadas. Coloca jugadores en el campo y guarda la primera.', lineupPlayersCount: '{{count}} jugadores', lineupShortcut: 'Atajo para {{name}}', noLineupShortcut: 'Sin atajo', saveName: 'Guardar', editOnBoard: 'Editar en el campo', overwriteLineup: 'Sobrescribir posiciones', renameLineup: 'Cambiar nombre', removeLineup: 'Eliminar', editingLineup: 'Editando alineación', editingLineupHint: 'Mueve los jugadores en el campo y guarda los cambios.', saveLineupChanges: 'Guardar cambios', cancelLineupEdit: 'Cancelar', lineupChangesSaved: 'Cambios de {{name}} guardados.', lineupEditCancelled: 'Edición de alineación cancelada.', emptySlot: 'Posición vacía', saveTeam1: 'Guardar E1', saveTeam2: 'Guardar E2', applyLineup: 'Aplicar', lineupSaved: 'Alineación {{slot}} guardada.', lineupApplied: 'Alineación {{slot}} aplicada.', lineupNeedsPlayers: 'Coloca primero jugadores del equipo seleccionado en el campo.', lineupEmpty: 'Esta alineación está vacía.',
    },
    emptyState: {
        title: 'Empieza tu pizarra',
        subtitle: 'Añade elementos para empezar a crear tu pizarra táctica',
        addPlayer: 'Añadir jugador',
        addPlayerHint: 'Coloca un jugador en el campo',
        addBall: 'Añadir balón',
        addBallHint: 'Coloca el balón en el campo',
        addArrow: 'Añadir flecha',
        addArrowHint: 'Dibuja un pase o carrera',
        commandPalette: 'Paleta de comandos',
    },
    auth: {
        continueFree: 'Continuar gratis',
        resetPassword: 'Restablecer contraseña',
        signInSubtitle: 'Inicia sesión para guardar tu trabajo y desbloquear el plan Free.',
        resetSubtitle: 'Introduce tu email para restablecer la contraseña',
        requiredFields: 'Rellena todos los campos obligatorios',
        passwordsMismatch: 'Las contraseñas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        verifyEmail: 'Cuenta creada. Abre el enlace de confirmación que enviamos. Revisa spam si no aparece.',
        devLogin: 'Inicio dev de prueba (omite auth)',
        freeTier: 'Bez Premium',
        proTier: 'Solo Premium',
        teamTier: 'Team Premium',
        continueGoogle: 'Continuar con Google',
        googlePopupTitle: 'Iniciando sesión con Google',
        googlePopupDescription: 'Termina el inicio de sesión en la ventana abierta. Puedes seguir trabajando en TMC Studio.',
        googleProgressTitle: 'Termina el inicio de sesión en Google',
        googleProgressDescription: 'La ventana de Google está abierta. Después de aprobar el acceso, TMC Studio volverá aquí automáticamente.',
        googleProgressWaiting: 'Esperando a Google...',
        popupRecoverySuccessTitle: 'El inicio de sesión terminó en esta ventana',
        popupRecoveryErrorTitle: 'No se pudo terminar el inicio de sesión',
        popupRecoveryDescription: 'Vuelve a la ventana principal de TMC Studio. Si no se actualizó, cierra esta ventana e inténtalo de nuevo.',
        popupRecoveryClose: 'Cerrar ventana',
        or: 'o',
        fullName: 'Nombre completo',
        fullNamePlaceholder: 'Juan Pérez',
        email: 'Email',
        emailPlaceholder: 'tu@example.com',
        password: 'Contraseña',
        confirmPassword: 'Confirmar contraseña',
        forgotPassword: '¿Olvidaste tu contraseña?',
        loading: 'Cargando…',
        signIn: 'Iniciar sesión',
        createAccount: 'Crear cuenta',
        sendResetLink: 'Enviar enlace de restablecimiento',
        noAccount: '¿No tienes cuenta?',
        signUp: 'Regístrate',
        alreadyAccount: '¿Ya tienes cuenta?',
        backToSignIn: 'Volver a iniciar sesión',
        freeForever: 'Free será gratis para siempre. Sin tarjeta.',
        errorInitFailed: 'No se pudo inicializar la autenticación',
        errorOfflineMode: 'La autenticación no está disponible en modo sin conexión',
        resetEmailSent: 'Enviamos un enlace para restablecer la contraseña. Revisa tu bandeja y spam.',
        errorEmailNotConfirmed: 'Confirma tu email antes de iniciar sesión. Revisa tu bandeja de entrada.',
        emailNotConfirmed: 'Tu email aún no ha sido confirmado. Revisa tu bandeja de entrada para el enlace de confirmación.',
        resendConfirmation: 'Reenviar email de confirmación',
        confirmationResent: 'Enviamos un nuevo enlace de confirmación. Revisa tu bandeja y spam.',
        newPassword: 'Nueva contraseña',
        confirmNewPassword: 'Confirmar nueva contraseña',
        resetPasswordTitle: 'Restablecer contraseña',
        resetPasswordSubtitle: 'Introduce tu nueva contraseña',
        resetPasswordSuccess: 'Contraseña restablecida correctamente. Redirigiendo a la aplicación…',
        resetPasswordVerifying: 'Verificando enlace de restablecimiento…',
        resetPasswordInvalid: 'El enlace de restablecimiento es inválido o ha expirado. Solicita uno nuevo.',
        resetPasswordEnterNew: 'Introduce una nueva contraseña',
        resetPasswordButton: 'Restablecer contraseña',
        resettingPassword: 'Restableciendo…',
        resetPasswordBackHome: '← Volver al inicio',
        authNotConfigured: 'La autenticación no está configurada',
        resetFailed: 'Error al restablecer la contraseña',
        callbackLoading: 'Iniciando sesión…',
        callbackTimeout: 'El inicio de sesión tardó demasiado. Inténtalo de nuevo.',
        callbackUnavailable: 'El inicio de sesión no está disponible ahora.',
        callbackSessionFailed: 'No pudimos crear tu sesión. Inténtalo de nuevo.',
        callbackFailed: 'No se pudo iniciar sesión. Inténtalo de nuevo.',
        callbackErrorTitle: 'No se pudo iniciar sesión',
        callbackErrorDescription: 'No pudimos completar el inicio de sesión.',
        callbackBack: 'Volver a TMC Studio',
    },
    confirm: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        processing: 'Procesando…',
    },
    exportToast: {
        canvasNotReady: 'El canvas no está listo',
        pngExported: 'PNG exportado.',
        exportingSteps: 'Exportando {{count}} pasos…',
        exportedPngs: '{{count}} PNG exportados.',
        gifPro: 'La exportación GIF es una función Pro',
        gifNeedSteps: 'Necesitas al menos 2 pasos para GIF',
        gifCreating: 'Creando GIF…',
        gifEncoding: 'Codificando GIF…',
        gifExported: 'GIF exportado.',
        gifFailed: 'Error al exportar GIF',
        pdfPro: 'La exportación PDF es una función Pro',
        pdfCreating: 'Creando PDF…',
        pdfExported: 'PDF exportado.',
        pdfFailed: 'Error al exportar PDF',
        svgExported: 'SVG exportado.',
        svgFailed: 'Error al exportar SVG',
        jpgExported: 'JPG exportado.',
    },
    billingToast: {
        signInFirst: 'Inicia sesión primero',
        portalFailed: 'No se pudo abrir el portal de facturación',
    },
    settingsToast: {
        profileUpdated: 'Perfil actualizado',
        passwordChanged: 'Contraseña cambiada',
        accountDeleted: 'Cuenta eliminada. Hasta pronto.',
    },
    projectToast: {
        loaded: 'Proyecto cargado',
        loadFailed: 'No se pudo cargar el proyecto',
        limitFree: 'Tienes {{count}}/3 elementos de este tipo. Mejora a Pro para ilimitados.',
        created: 'Nuevo proyecto creado',
        savedCloud: 'Proyecto guardado en la nube',
        saveCloudFailed: 'No se pudo guardar en la nube',
        cloudSaveError: 'Error al guardar en la nube. Revisa la consola.',
        deleted: 'Proyecto eliminado',
        deletedMany: 'Se eliminaron {{count}} proyectos',
        deletedManyPartial: 'Se eliminaron {{count}} de {{total}} proyectos',
        deleteFailed: 'No se pudo eliminar el proyecto',
        duplicated: 'Proyecto duplicado',
        renamed: 'Proyecto renombrado',
        refreshed: 'Proyectos actualizados',
        graphicAttached: 'El gráfico "{{name}}" se añadió al ejercicio',
        folderCreated: 'Carpeta "{{name}}" creada',
        folderCreateFailed: 'No se pudo crear la carpeta',
        folderUpdated: 'Carpeta "{{name}}" actualizada',
        folderUpdateFailed: 'No se pudo actualizar la carpeta',
        deleteFolderTitle: '¿Eliminar carpeta?',
        deleteFolderDescription: 'Esto eliminará la carpeta y cualquier subcarpeta dentro. Tus proyectos no se eliminarán; permanecerán en tu espacio de trabajo.',
        deleteFolderConfirm: 'Eliminar carpeta',
        folderDeleted: 'Carpeta eliminada',
        folderDeleteFailed: 'No se pudo eliminar la carpeta',
        favoriteAdded: 'Añadido a favoritos',
        favoriteRemoved: 'Eliminado de favoritos',
        favoriteFailed: 'No se pudo actualizar favorito',
        movedToFolder: 'Proyecto movido a carpeta',
        removedFromFolder: 'Proyecto eliminado de la carpeta',
        moveProjectFailed: 'No se pudo mover el proyecto',
        tagsFailed: 'No se pudieron guardar las etiquetas',
        projectPinned: 'Proyecto fijado',
        projectUnpinned: 'Proyecto desfijado',
        pinProjectFailed: 'No se pudo actualizar el fijado',
        folderPinned: 'Carpeta fijada',
        folderUnpinned: 'Carpeta desfijada',
        pinFolderFailed: 'No se pudo actualizar el fijado de carpeta',
        renameProjectFailed: 'No se pudo renombrar el proyecto',
        folderMoved: 'Carpeta movida',
        folderMoveFailed: 'No se pudo mover la carpeta',
        folderRenamed: 'Carpeta renombrada',
        renameFolderFailed: 'No se pudo renombrar la carpeta',
    },
    limits: {
        guestTitle: 'Has alcanzado el límite Guest',
        freeTitle: 'Límite del plan Free alcanzado',
        guestOne: 'Ya tienes {{count}} {{resource}} — el modo Guest permite solo uno.',
        guestMany: 'Has añadido {{count}} {{resource}} — ese es el límite Guest.',
        freeOne: 'Ya tienes {{count}} {{resource}} — el plan Free permite {{max}}.',
        freeMany: 'Has creado {{count}} {{resource}} — ese es el límite del plan Free.',
        guestDescription: 'Estás usando TMC Studio sin cuenta. Crea una cuenta gratuita para seguir creando y guardar tu trabajo.',
        freeDescription: 'Has alcanzado el límite del plan Free. Actualiza a Pro para continuar sin restricciones.',
        guestBenefits: '3 gráficos, ejercicios y sesiones de cada tipo|10 pasos por proyecto|Sincronización y backup en la nube|Exportación PNG',
        proBenefits: 'Proyectos ilimitados|Pasos ilimitados|Exportación GIF y PDF|Soporte prioritario',
        continueFree: 'Continuar gratis',
        upgradePro: 'Actualizar a Pro',
        guestUsage: 'Uso Guest',
        freePlan: 'Plan Free',
        whatYouGet: 'Qué obtienes:',
        comparePlans: 'Comparar planes',
        reassurance: 'Free será gratis para siempre. Sin tarjeta.',
        steps: 'pasos',
        step: 'paso',
        projects: 'proyectos',
        project: 'proyecto',
    },
    folders: {
        createTitle: 'Crear carpeta',
        optionsTitle: 'Opciones de carpeta',
        name: 'Nombre de carpeta',
        placeholder: 'p. ej. Tácticas, Entrenamientos…',
        color: 'Color de carpeta',
        cancel: 'Cancelar',
        create: 'Crear carpeta',
        save: 'Guardar',
    },
    coaching: {
        library: 'Biblioteca', projectName: 'Nombre del proyecto', saving: 'Guardando…', saved: 'Guardado', saveError: 'Error al guardar', help: 'Guía rápida', quickStart: 'Inicio rápido', start: 'Empezar', backToBoard: 'Volver a la pizarra',
        exercise: {
            workspaceTitle: 'Editor de ejercicio', nameLabel: 'Nombre del ejercicio', graphic: 'Gráfico táctico', editGraphic: 'Editar gráfico en la pizarra', editGraphicShort: 'Editar', drawOnBoard: 'Volver a la pizarra y dibujar', openBoard: 'Volver a la pizarra y dibujar', backToExercise: 'Terminar edición del gráfico', noGraphic: 'Elige un gráfico guardado o abre la pizarra para crear uno.', chooseGraphic: 'Elegir gráfico de la biblioteca', downloadPdf: 'Descargar PDF', print: 'Imprimir', pdfError: 'No se pudo crear el PDF. Inténtalo de nuevo.', duration: 'Duración total (min)', players: 'Jugadores', intervals: 'Series y descansos', intervalsHint: 'Planifica, por ejemplo, 2 × 7 min con un minuto de descanso.', clearIntervals: 'Limpiar', sets: 'Series', workMinutes: 'Trabajo (min)', restMinutes: 'Descanso (min)', category: 'Categoría / fase', categoryPlaceholder: 'p. ej. calentamiento, presión, salida', objective: 'Objetivo', objectivePlaceholder: '¿Qué deben aprender los jugadores?', description: 'Contenido del ejercicio', descriptionPlaceholder: 'Describe las reglas y el desarrollo.', organization: 'Organización', coachingPoints: 'Puntos de entrenamiento', progression: 'Progresión / regresión', equipment: 'Material',
            guide: { title: 'Crea un ejercicio completo', 1: { title: 'Añade el gráfico', body: 'Elige un dibujo existente o prepara uno nuevo en el editor de pizarra.' }, 2: { title: 'Describe el trabajo', body: 'Define objetivo, organización, duración, jugadores y material.' }, 3: { title: 'Guarda y reutiliza', body: 'El ejercicio se guarda automáticamente y queda disponible en cada sesión.' } },
        },
        session: {
            loadPresetGroups: 'Cargar grupos',
            exportPdf: 'Descargar PDF', nameLabel: 'Nombre de la sesión', downloadPdf: 'Descargar PDF', downloadingPdf: 'Creando PDF…', print: 'Imprimir', pdfError: 'No se pudo crear el PDF. Inténtalo de nuevo.', eyebrow: 'Plan de sesión de entrenamiento', totalTime: 'Duración total', date: 'Fecha', microcycleDay: 'Día del microciclo', venue: 'Lugar', startTime: 'Hora', staff: 'Cuerpo técnico', objectives: 'Objetivos de la sesión', microcycle: 'Microciclo', mesocycle: 'Mesociclo', playerCount: 'Jugadores', exerciseLibrary: 'Biblioteca de ejercicios', exerciseLibraryHint: 'Añade ejercicios guardados directamente a la sesión.', searchExercises: 'Buscar ejercicios…', noExercises: 'No hay ejercicios coincidentes.', trainingContent: 'Contenido del entrenamiento', emptyPlan: 'Añade el primer ejercicio desde la biblioteca.', exerciseNotes: 'Contenido, reglas, variantes y notas…', squad: 'Plantilla', newGroup: 'Nuevo grupo', addGroup: 'Añadir grupo de posición', playersPlaceholder: 'Un jugador por línea', workOrganization: 'Organización del cuerpo técnico', addStaff: 'Añadir técnico', coach: 'Técnico', beforeTraining: 'Antes del entrenamiento', exerciseShort: 'Ej.', organizationNotes: 'Organización de espacios / material', equipmentNotes: 'Material y preparación', lineupNotes: 'Alineaciones y notas adicionales',
            guide: { title: 'Crea un plan de entrenamiento', 1: { title: 'Completa los datos', body: 'Define fecha, MD, lugar, técnicos, objetivos, cargas y plantilla.' }, 2: { title: 'Añade ejercicios', body: 'Usa la biblioteca y define orden, duración e instrucciones de cada bloque.' }, 3: { title: 'Organiza y exporta', body: 'Asigna responsabilidades, añade material y guarda o imprime el plan en PDF.' } },
        },
    },
    pricing: {
        title: 'Elige cómo quieres usar TMC Studio',
        subtitle: 'Empieza gratis. Actualiza solo si necesitas más.',
        mostPopular: 'Más popular',
        currentPlan: 'Plan actual',
        billing: {
            monthly: 'Mensual',
            yearly: 'Anual',
            perMonth: '/mes',
            perYear: '/año',
            yearlyHint: '2 meses gratis',
        },
        processing: 'Procesando…',
        signInHint: 'Inicia sesión con Google o email',
        footer: 'Puedes usar TMC Studio gratis para siempre.',
        footerSecond: 'Actualiza solo cuando alcances un límite real.',
        checkoutFailed: 'Checkout fallido. Inténtalo de nuevo.',
        checkoutSessionFailed: 'No se pudo crear la sesión de checkout',
        genericError: 'Algo salió mal',
        plans: {
            free: {
                name: 'Free',
                price: 'Incluido',
                period: ' tras iniciar sesión',
                microcopy: 'Este es el plan predeterminado después del login',
                features: '3 gráficos, ejercicios y sesiones de cada tipo|Sincronización y backup en la nube|Exportación PNG|Organización con carpetas',
                cta: 'Continuar gratis',
            },
            pro: {
                name: 'Pro',
                price: '$9',
                period: '/mes',
                microcopy: 'Para entrenadores que crean muchos ejercicios y exportaciones',
                features: 'Proyectos ilimitados|Exportación GIF y PDF|Pasos ilimitados|Soporte prioritario',
                cta: 'Actualizar a Pro',
            },
            team: {
                name: 'Team',
                price: '$29',
                period: '/mes',
                microcopy: 'Pro + invita a tu staff con un enlace seguro',
                features: '5 miembros de equipo|Facturación compartida|Espacios de trabajo individuales|Todo lo de Pro',
                cta: 'Actualizar a Team',
            },
        },
    },
    projects: {
        title: 'Proyectos',
        back: 'Volver',
        recentProjects: 'Proyectos recientes',
        recentHint: 'Continúa donde lo dejaste',
        refresh: 'Actualizar proyectos',
        close: 'Cerrar panel',
        newProject: 'Nuevo proyecto',
        defaultExerciseName: 'Nuevo ejercicio',
        defaultSessionName: 'Nuevo plan de sesión',
        defaultSessionNameWithDate: 'Entrenamiento - {date}',
        exerciseFromGraphicName: 'Ejercicio — {{name}}',
        kind: 'Tipo',
        folder: 'Carpeta',
        noFolder: 'Sin carpeta',
        tags: 'Etiquetas',
        addTag: 'Añade una etiqueta y pulsa Enter',
        removeTag: 'Quitar etiqueta {{tag}}',
        organize: 'Carpeta y etiquetas',
        organizeTitle: 'Carpeta y etiquetas: {{name}}',
        done: 'Listo',
        filterByType: 'Filtrar por tipo',
        descriptionPlaceholder: 'Objetivo, organización, desarrollo y puntos clave…',
        tutorial: {
            help: 'Cómo funciona', open: 'Tutorial de biblioteca', close: 'Cerrar tutorial', step: 'Paso {{current}} de 3', back: 'Atrás', next: 'Siguiente', done: 'Listo',
            items: {
                0: { title: '1. Dibuja un gráfico', body: 'Guarda la disposición del campo como Gráfico. Será la base visual del ejercicio.' },
                1: { title: '2. Crea un ejercicio', body: 'Crea un ejercicio desde el gráfico actual o elige uno de la biblioteca. Añade duración, jugadores, organización y puntos clave.' },
                2: { title: '3. Prepara la sesión', body: 'Añade ejercicios al plan, define orden, duración y notas. El tiempo total se calcula automáticamente.' },
            },
        },
        exercise: {
            createFromThisGraphic: 'Crear ejercicio desde este gráfico', graphic: 'Gráfico del ejercicio', noGraphics: 'Crea primero un gráfico', useGraphic: 'Usar gráfico', refreshGraphic: 'Actualizar desde gráfico', usingGraphic: 'Gráfico usado: {{name}}', duration: 'Duración (min)', players: 'Jugadores', playersPlaceholder: 'p. ej. 8 + 2 porteros', organization: 'Organización y desarrollo', coachingPoints: 'Puntos clave',
        },
        session: {
            agenda: 'Plan de ejercicios', total: 'Total: {{minutes}} min', noExercises: 'Crea primero un ejercicio', add: 'Añadir', empty: 'Añade el primer ejercicio al plan.', moveUp: 'Mover arriba', moveDown: 'Mover abajo', remove: 'Quitar de la sesión', itemDuration: 'Duración del ejercicio en minutos', notes: 'Notas para este ejercicio',
        },
        type: { all: 'Todos', graphic: 'Gráfico', exercise: 'Ejercicio', session: 'Plan de sesión' },
        search: 'Buscar proyectos…',
        clearSearch: 'Limpiar búsqueda',
        sortBy: 'Ordenar:',
        results: '{{count}} resultado(s)',
        pinned: 'Fijados',
        folders: 'Carpetas',
        newFolder: 'Nueva carpeta',
        newSubfolder: 'Nueva subcarpeta',
        allProjects: 'Todos los proyectos',
        unsorted: 'Sin clasificar', selectProject: 'Seleccionar {{name}}', unselectProject: 'Deseleccionar {{name}}', selectedCount: 'Seleccionados: {{count}}', selectAll: 'Seleccionar visibles', clearSelection: 'Limpiar', deleteSelected: 'Eliminar seleccionados', deleteSelectedTitle: '¿Eliminar {{count}} proyectos?', deleteSelectedDescription: 'Los proyectos seleccionados se eliminarán permanentemente. Los planes conservan las vistas guardadas de los ejercicios.',
        moveToRoot: 'Mover a raíz',
        noProjectsYet: 'Aún no hay proyectos',
        createProject: 'Crear proyecto',
        signInSync: 'Inicia sesión para sincronizar proyectos',
        authRequired: 'Los proyectos en la nube requieren autenticación',
        signIn: 'Iniciar sesión',
        createFirst: 'Crea tu primer proyecto para empezar',
        cloudSync: 'Sincronización en la nube activada',
        signInCloud: 'Inicia sesión para sincronizar con la nube',
        current: 'Actual',
        projectName: 'Nombre del proyecto',
        saving: 'Guardando…',
        unsaved: 'Cambios sin guardar',
        saveError: 'Error de guardado',
        saved: 'Guardado',
        duplicate: 'Duplicar',
        projectActions: 'Acciones del proyecto {{name}}',
        delete: 'Eliminar',
        unpin: 'Desfijar',
        pinTop: 'Fijar arriba',
        removeFavorite: 'Quitar de favoritos',
        addFavorite: 'Añadir a favoritos',
        editFolder: 'Editar carpeta',
        moveRoot: 'Mover a raíz',
        deleteFolder: 'Eliminar carpeta',
        dropInside: 'Soltar dentro',
        dropAbove: 'Soltar arriba',
        dropBelow: 'Soltar abajo',
        dragReorder: 'Arrastra para reordenar',
        expand: 'Expandir',
        collapse: 'Contraer',
        deleteTitle: 'Eliminar proyecto',
        deleteDescription: '¿Seguro que quieres eliminar "{{name}}"? Esta acción no se puede deshacer.',
        deleteFallback: '¿Seguro que quieres eliminar este proyecto?',
        sort: {
            recent: 'Recientes',
            nameAsc: 'Nombre (A-Z)',
            nameDesc: 'Nombre (Z-A)',
            favorites: 'Favoritos primero',
            lastOpened: 'Último abierto',
        },
        time: {
            justNow: 'Ahora mismo',
            minutesAgo: 'hace {{count}} min',
            hoursAgo: 'hace {{count}} h',
            daysAgo: 'hace {{count}} d',
        },
    },
    help: {
        panelLabel: 'Panel de ayuda',
        title: 'Ayuda y atajos',
        close: 'Cerrar panel de ayuda',
        shortcuts: 'Atajos de teclado',
        quickTools: 'Herramientas rápidas',
        tips: 'Consejos',
        tutorial: 'Tutorial',
        restartTutorial: 'Reiniciar guía interactiva',
        saveStatus: 'Estado de guardado',
        save: 'Guardar',
        allSaved: 'Todos los cambios guardados',
        saving: 'Guardando…',
        unsaved: 'Cambios sin guardar',
        error: 'Error de guardado',
        tools: {
            'zoom-fit': { label: 'Ajustar zoom', description: 'Ajustar vista al campo' },
            'focus-mode': { label: 'Modo enfoque', description: 'UI mínima para trabajar sin distracciones' },
            'print-mode': { label: 'Modo impresión', description: 'Diseño limpio para exportar' },
            export: { label: 'Exportar', description: 'Exportar como PNG/PDF/GIF' },
        },
        tipsList: {
            'tip-1': 'Selecciona un jugador y pulsa → para añadir una flecha con número',
            'tip-2': 'Haz doble clic en un jugador para editar rápido su número',
            'tip-3': 'Mantén Shift al hacer clic para seleccionar varios elementos',
            'tip-4': 'Pulsa ? para ver la hoja completa de atajos',
            'tip-5': 'Usa Ctrl+Scroll para acercar y alejar',
            'tip-6': 'Space + arrastrar para mover el lienzo',
        },
    },
    faq: {
        title: 'Centro de ayuda',
        subtitle: 'Encuentra respuestas a preguntas frecuentes',
        search: 'Buscar ayuda…',
        noResults: 'No se encontraron preguntas. Intenta con otra búsqueda.',
        categories: {
            gettingStarted: 'Primeros pasos',
            proFeatures: 'Funciones Pro',
            clubPremium: 'Club Premium',
            troubleshooting: 'Solución de problemas',
            accountBilling: 'Cuenta y facturación',
            coachingWorkflow: 'Biblioteca y flujo del entrenador',
        },
        items: {
            addPlayer: { question: '¿Cómo añado un jugador?', answer: 'Pulsa P para añadir un jugador local, o Shift+P para un visitante. También puedes hacer clic derecho en el campo y seleccionar "Añadir jugador". Usa las teclas 1-6 para formaciones instantáneas.' },
            addArrow: { question: '¿Cómo dibujo flechas?', answer: 'Pulsa A para flechas de pase (sólidas), R para carreras (discontinuas) o S para tiros (doble línea). Haz clic en el campo, arrastra al punto final y suelta. Shift+N activa la auto-numeración.' },
            saveProject: { question: '¿Cómo guardo mi proyecto?', answer: 'Pulsa ⌘S (Ctrl+S en Windows) para guardar. Los proyectos se guardan automáticamente en la nube cada 30 segundos. Abre el panel de Proyectos (icono de carpeta en TopBar) para ver, renombrar u organizar.', cta: 'Guardar ahora' },
            freePlan: { question: '¿Qué puedo hacer gratis?', answer: 'El plan Gratuito incluye tres gráficos, ejercicios y planes de sesión de cada tipo, 10 pasos por proyecto, exportación PNG y JPG, y sincronización en la nube.', cta: 'Comparar planes' },
            exportGifPdf: { question: '¿Cómo exporto GIF o PDF?', answer: 'La exportación GIF y PDF son funciones Pro. Haz clic en Exportar en la TopBar y selecciona "Animación GIF" o "PDF". Si no ves estas opciones, estás en el plan gratuito.', cta: 'Actualizar a Pro' },
            unlimitedProjects: { question: '¿Puedo crear proyectos ilimitados?', answer: 'Los proyectos y pasos ilimitados están disponibles en el plan Pro. El plan gratuito permite tres elementos de cada tipo con 10 pasos cada uno.', cta: 'Ver planes Pro' },
            manageSubscription: { question: '¿Cómo gestiono mi suscripción?', answer: 'Haz clic en tu avatar en la TopBar y selecciona "Cuenta y facturación". Se abrirá el Portal de Clientes de Stripe donde puedes actualizar métodos de pago, ver facturas o cambiar tu plan.', cta: 'Abrir facturación' },
            squadSlots: { question: '¿Cuántos jugadores puedo tener en mi plantilla?', answer: 'El plan gratuito permite hasta 5 jugadores en plantilla. Pro y Club Premium desbloquean hasta 35 jugadores por equipo (140 en total en 4 equipos). Las plazas bloqueadas muestran un candado.', cta: 'Actualizar para más plazas' },
            addMembers: { question: '¿Cómo añado miembros al equipo?', answer: 'Abre los ajustes de Team, introduce el email y crea un enlace de invitación. Compártelo con esa persona; obtendrá acceso cuando lo acepte con la cuenta indicada.', cta: 'Abrir panel de equipo' },
            manageBilling: { question: '¿Cómo gestiono la facturación de Club Premium?', answer: 'Haz clic en tu avatar → "Cuenta y facturación" para abrir el Portal de Clientes de Stripe. Aquí puedes actualizar métodos de pago, ver facturas y gestionar tu suscripción.', cta: 'Abrir facturación' },
            removeMember: { question: '¿Cómo elimino un miembro del equipo?', answer: 'Abre el panel de Equipo en el Inspector. Busca el miembro que quieres eliminar y haz clic en el icono de papelera junto a su nombre. Confirma para revocar su acceso a Club Premium inmediatamente.' },
            saveFailed: { question: 'Mi proyecto no se guardó. ¿Qué hago?', answer: 'Primero verifica tu conexión a Internet. Si estás online, prueba un guardado manual con ⌘S (Ctrl+S en Windows). El icono de error en la barra de estado es cliqueable — reintenta el guardado automáticamente.', cta: 'Guardado manual' },
            changesNotVisible: { question: 'No veo mis cambios en la pizarra', answer: 'Asegúrate de que la capa correcta está visible (Inspector → pestaña Capas). Verifica que estás en el paso correcto (línea de tiempo inferior). Pulsa 0 para restablecer la vista, o comprueba si estás en Modo Impresión (W).' },
            exportNotWorking: { question: 'La exportación no funciona', answer: 'Para exportación PNG, verifica los permisos del navegador (algunos bloquean descargas). Para GIF, asegúrate de tener al menos 2 pasos con contenido diferente. Para PDF, verifica que tienes el plan Pro.' },
            changePlan: { question: '¿Cómo cambio mi plan?', answer: 'Haz clic en tu avatar en la TopBar y selecciona "Cuenta y facturación" para gestionar tu suscripción, o abre el modal de Precios para comparar planes y actualizar.', cta: 'Ver planes' },
            cancelSubscription: { question: '¿Cómo cancelo mi suscripción?', answer: 'Haz clic en tu avatar → "Cuenta y facturación" para abrir el Portal de Clientes de Stripe. Selecciona "Cancelar plan" — tu acceso continuará hasta el final del período de facturación.', cta: 'Ir a facturación' },
            guestRegister: { question: '¿Cómo creo una cuenta gratuita?', answer: 'Haz clic en "Iniciar sesión" en el menú de la TopBar y selecciona "Registrarse". Usa Google para registro con un clic, o introduce tu email y contraseña. Gratis sigue siendo gratis — sin tarjeta de crédito.', cta: 'Registrarse gratis' },
            lineupPresets: { question: '¿Cómo guardo y cargo una alineación rápidamente?', answer: 'Coloca jugadores, abre Ajustes → Plantilla y guarda una alineación con nombre. Cárgala bajo el nombre del equipo o con Option+1–9 en macOS y Alt+1–9 en Windows/Linux. El lápiz abre la edición rápida.' },
            exercisesSessions: { question: '¿Cómo creo un ejercicio y una sesión?', answer: 'Crea un Gráfico en Proyectos, después un Ejercicio y adjunta el gráfico. Añade organización, coaching points e intervalos. En una Sesión ordena ejercicios, elige plantilla y cuerpo técnico, y exporta PDF.' },
            returnFromLineupEdit: { question: '¿A dónde vuelvo después de editar?', answer: 'TMC Studio vuelve al origen. Desde Ajustes vuelve a Plantilla; desde el banquillo guarda y permanece en la pizarra.' },
        },
    },
    bottomSteps: {
        previous: 'Paso anterior (←)',
        play: 'Reproducir (Space)',
        pause: 'Pausa (Space)',
        next: 'Paso siguiente (→)',
        loop: 'Bucle (L)',
        duration: 'Duración del paso (velocidad de reproducción)',
        rename: 'Doble clic para renombrar',
        delete: 'Eliminar paso (X)',
        duplicate: 'Duplicar paso',
        moveHint: 'Arrastra para reordenar (Alt+←/→) · doble clic para renombrar',
        add: 'Añadir paso (N)',
        counter: 'Paso {{current}} / {{total}}',
        defaultName: 'Paso {{number}}',
    },
    selection: {
        duplicate: 'Duplicar (⌘D)',
        bringFront: 'Traer al frente',
        sendBack: 'Enviar al fondo',
        delete: 'Eliminar (Del)',
    },
    teamsPanel: {
        title: 'Colores de equipo',
        teamSuffix: '{{team}}',
        name: 'Nombre',
        primaryColor: 'Color principal',
        secondaryColor: 'Color secundario',
        goalkeeperColor: 'Color del portero',
        kitPresets: 'Kits predefinidos',
        kits: {
            redWhite: 'Rojo y blanco',
            blueWhite: 'Azul y blanco',
            greenWhite: 'Verde y blanco',
            blackWhite: 'Negro y blanco',
            whiteBlack: 'Blanco y negro',
            yellowBlue: 'Amarillo y azul',
            orangeBlack: 'Naranja y negro',
            navySkyblue: 'Azul marino y celeste',
        },
        help: 'Los nombres y colores se guardan automáticamente y se aplican inmediatamente a todos los jugadores.',
        team1: 'Equipo 1',
        team2: 'Equipo 2',
        team3: 'Equipo 3',
        team4: 'Equipo 4',
    },
    squadBench: {
        title: 'Banquillo',
        home: 'Local',
        away: 'Visitante',
        team3: 'Equipo 3',
        team4: 'Equipo 4',
        empty: 'vacío',
        add: 'añadir',
        addPlayer: 'Añadir jugador',
        addSquadPlayer: 'Añadir jugador a la plantilla',
        addFirstPlayer: 'Añadir primer jugador',
        upgradeSlots: 'Mejora a Pro para más espacios de plantilla',
        unlockSlots: 'Mejora a Pro para desbloquear más espacios de plantilla',
        freeLimitNotice: 'El modo gratuito permite {{freeLimit}} jugadores en plantilla. Inicia sesión para guardar tu plantilla; Pro desbloquea hasta {{premiumLimit}} jugadores por equipo.',
        dragToPitch: '{{name}} (#{{number}}) — arrastra al campo',
        playerAria: '{{name}}, número {{number}}, {{team}}{{locked}}',
        locked: ' — bloqueado',
        remove: 'Eliminar {{name}}',
        removeAria: 'Eliminar {{name}} de la plantilla',
        editor: 'Editor completo de plantilla en Ajustes',
        editRoster: 'Editar plantilla',
        hide: 'Ocultar banquillo',
        show: 'Mostrar banquillo',
        switchCurrent: 'Cambiar equipo — actual: {{team}}',
        currentTeam: 'Equipo actual: {{team}}. Haz clic para cambiar.',
        teamCount: '{{team}} ({{count}})',
        switchToTeam: 'Cambiar a {{team}} ({{count}} jugadores)',
        namePlaceholder: 'Jugador',
        numberPlaceholder: '#',
        cancel: 'Cancelar',
        dragHint: 'Arrastra un jugador al campo para colocarlo',
        collapsedSetup: 'Configura tu plantilla en Ajustes o',
        collapsedCount: '{{count}} en plantilla — toca el ojo para mostrar',
        teams: 'Equipos', tacticalLineups: 'Alineaciones tácticas', chooseTacticalLineup: 'Elegir alineación', editSelectedLineup: 'Opciones de la alineación', applySelectedLineup: 'Aplicar', editOnPitch: 'Editar en el campo', noTacticalLineups: 'No hay alineaciones guardadas para este equipo.', closeTeamMenu: 'Cerrar menú de equipo',
    },
    pitchPanel: {
        boardView: 'Vista del campo',
        boardFull: 'Campo completo',
        boardHalf2d: 'Medio campo',
        boardPenalty2d: 'Área de penalti',
        boardResetTitle: '¿Restablecer pizarra?',
        boardResetDesc: 'Esto elimina todos los elementos y restaura la configuración predeterminada. No se puede deshacer.',
        boardResetConfirm: 'Restablecer pizarra',
        title: 'Apariencia del campo',
        theme: 'Tema',
        grass: 'Césped',
        indoor: 'Indoor',
        chalk: 'Tiza',
        futsal: 'Futsal',
        showStripes: 'Mostrar franjas',
        withoutLines: 'Sin líneas',
        printFriendly: 'Modo impresión',
        customColors: 'Colores personalizados',
        fieldColor: 'Color del campo',
        lineColor: 'Color de líneas',
        orientation: 'Orientación',
        landscape: 'Horizontal',
        portrait: 'Vertical',
        help: 'Elige un tema predefinido o personaliza los colores.',
    },
    tutorial: {
        finish: 'Finalizar',
        step: 'Paso {{current}} de {{total}}',
        skip: 'Omitir',
        back: 'Atrás',
        next: 'Siguiente',
        startBuilding: 'Empezar a entrenar',
        ariaStep: 'Paso del tutorial {{id}}: {{title}}',
        demos: {
            fastInput: 'Añadido rápido',
            homePlayer: 'Jugador local',
            awayPlayer: 'Jugador visitante',
            formation: 'Formación',
            arrows: 'Tipos de flechas',
            passArrow: 'Pase',
            runArrow: 'Carrera',
            shootArrow: 'Tiro',
            autoNumber: 'Auto-numeración',
            inspector: 'Inspector',
            output: 'Formatos de exportación',
            share: 'Compartir',
            projects: 'Proyectos',
            threePerType: '3 / tipo',
            cloud: 'Nube',
            pro: 'Pro',
            squad: 'Plantilla',
            steps: 'Línea de tiempo',
            play: 'Reproducir',
            newStep: 'Nuevo paso',
            loop: 'Bucle',
            save: 'Guardar y proyectos',
            saveShortcut: 'Guardar',
            myProject: 'Mi ejercicio',
            justNow: 'Ahora mismo',
            saved: 'Guardado',
            shortcutSheet: 'Hoja de atajos',
            team: 'Gestión de equipo',
            admin: 'Admin',
            member: 'Miembro',
            active: 'Activo',
            inviteMember: 'Invitar miembro',
        },
        steps: {
            1: { eyebrow: '🏋️ Calentamiento', title: 'Coloca tus jugadores', description: 'Pulsa P para añadir jugadores locales, Shift+P para visitantes. Usa las teclas 1-6 para formaciones instantáneas. Tu pizarra táctica comienza aquí.', target: 'Añadir jugadores', cta: 'Dibujar táctica' },
            2: { eyebrow: '🏃 Movimiento', title: 'Dibuja tu táctica', description: 'Pulsa A para flechas de pase, R para carreras, S para tiros. Haz clic y arrastra en el campo para mostrar exactamente cómo debe moverse tu equipo.', target: 'Flechas tácticas', cta: 'Establecer dirección' },
            3: { eyebrow: '🧭 Dirección', title: 'Muestra hacia dónde miran', description: 'Selecciona un jugador y pulsa [ o ] para rotarlo. Pulsa V para mostrar su cono de visión — perfecto para ejercicios de presión y forma defensiva.', target: 'Orientación', cta: 'Añadir equipamiento' },
            4: { eyebrow: '🏋️ Equipamiento', title: 'Construye tu ejercicio', description: 'Añade porterías (J), conos (K), escaleras (Y) y vallas (U). Usa Z para zonas, T para texto. Todo lo que un entrenador necesita para una sesión.', target: 'Equipamiento', cta: 'Gestionar plantilla' },
            5: { eyebrow: '📋 Plantilla', title: 'Toda tu plantilla a mano', description: 'El Squad Bench guarda tus jugadores. Arrástralos al campo para sustituir o añadir nuevos roles. Haz clic en el ojo para mostrar/ocultar.', target: 'Banquillo', cta: 'Animar táctica' },
            6: { eyebrow: '▶️ Animación', title: 'Dale vida a tu táctica', description: 'Pulsa N para añadir un nuevo paso, luego ajusta posiciones. Pulsa Space para reproducir — observa cómo tu ejercicio se anima paso a paso. Bucle con L.', target: 'Línea de tiempo', cta: 'Guardar proyecto' },
            7: { eyebrow: '📚 Biblioteca', title: 'Convierte gráficos en sesiones', description: 'Abre Proyectos: guarda el campo como Gráfico, conviértelo en Ejercicio con detalles y añade ejercicios a un Plan de sesión ordenado.', target: 'Biblioteca de entrenador', cta: 'Compartir y exportar' },
            8: { eyebrow: '📤 Compartir', title: 'Exporta y comparte con tu equipo', description: 'Exporta tu ejercicio como PNG, animación GIF o PDF. Pulsa ? para ver la hoja completa de atajos. Tu biblioteca táctica lista para el partido.', target: 'Exportar', cta: 'Empezar a entrenar' },
        },
    },
    cheatsheet: {
        title: 'Atajos de teclado',
        close: 'Cerrar (o pulsa ?)',
        closeShortcuts: 'Cerrar atajos (?)',
        keyboardShortcuts: 'Atajos de teclado (?)',
        closeAria: 'Cerrar atajos de teclado',
        showAria: 'Mostrar atajos de teclado',
        categories: 'Categorías de atajos',
        press: 'Pulsa',
        toToggle: 'para alternar',
        tabs: { Elements: 'Elementos', Edit: 'Edición', View: 'Vista', More: 'Más' },
        sections: {
            'Elements': 'Elementos', 'Edit': 'Edición', 'View & Pitch': 'Vista y campo',
            'Steps & Playback': 'Pasos y reproducción', 'Export': 'Exportar',
            'Formations': 'Formaciones', 'Arrow Numbering': 'Numeración de flechas',
        },
    },
    palette: {
        placeholder: 'Escribe un comando o busca…',
        noResults: 'No se encontraron comandos',
        pro: 'Pro',
        navigate: 'navegar',
        select: 'seleccionar',
        close: 'cerrar',
        categories: { elements: 'Elementos', edit: 'Edición', view: 'Vista', steps: 'Pasos', export: 'Exportar', presets: 'Plantillas' },
    },
    commands: {
        'add-home-player': 'Añadir jugador local',
        'add-away-player': 'Añadir jugador visitante',
        'add-ball': 'Añadir balón',
        'add-pass-arrow': 'Añadir flecha de pase',
        'add-run-arrow': 'Añadir flecha de carrera',
        'add-shoot-arrow': 'Añadir flecha de tiro',
        'add-dribble-arrow': 'Añadir flecha de regate',
        'add-zone': 'Añadir zona',
        'add-ellipse-zone': 'Añadir zona elíptica',
        'add-freehand-draw': 'Añadir dibujo a mano alzada',
        'add-text': 'Añadir texto',
        'duplicate': 'Duplicar selección',
        'delete': 'Eliminar selección',
        'undo': 'Deshacer',
        'redo': 'Rehacer',
        'select-all': 'Seleccionar todo',
        'clear-selection': 'Borrar selección',
        'toggle-inspector': 'Alternar inspector',
        'toggle-cheatsheet': 'Alternar atajos',
        'toggle-grid': 'Alternar cuadrícula',
        'toggle-snap': 'Alternar ajuste',
        'focus-mode': 'Modo enfoque',
        'add-step': 'Añadir paso',
        'prev-step': 'Paso anterior',
        'next-step': 'Paso siguiente',
        'play': 'Reproducir',
        'pause': 'Pausa',
        'toggle-loop': 'Alternar bucle',
        'export-png': 'Exportar PNG',
        'export-steps': 'Exportar todos los pasos PNG',
        'export-gif': 'Exportar GIF animado',
        'export-pdf': 'Exportar PDF (todos los pasos)',
        'export-svg': 'Exportar SVG',
        confirm: {
            clearAllTitle: '¿Borrar todos los elementos?',
            clearAllDescription: 'Esto eliminará todos los elementos del paso actual. Puedes deshacer esta acción con Cmd+Z.',
            clearAllConfirm: 'Borrar todo',
        },
        toast: {
            groupUngrouped: 'Grupo desagrupado',
            selectionLockToggled: 'Bloqueo alternado',
            selectionLocked: 'Selección bloqueada',
            selectionUnlocked: 'Selección desbloqueada',
            team1Player: 'Jugador del equipo 1',
            team2Player: 'Jugador del equipo 2',
            team3Player: 'Jugador del equipo 3',
            team4Player: 'Jugador del equipo 4',
            ballCluster: 'Grupo de balones',
            ball: 'Balón',
            text: 'Texto',
            lyingMannequin: 'Maniquí tumbado',
            mannequin: 'Maniquí',
            discMarker: 'Disco marcador',
            pole: 'Pica',
            cone: 'Cono',
            hoop: 'Aro',
            hurdle: 'Valla',
            ladder: 'Escalera',
            miniGoal: 'Mini portería',
            goal: 'Portería',
            redo: 'Rehecho',
            undo: 'Deshecho',
            deleted: 'Eliminado',
            duplicated: 'Duplicado',
            dribbleArrow: 'Flecha de regate',
            copied: 'Copiado',
            allElementsCleared: 'Todos los elementos borrados',
            noDrawingsToClear: 'No hay dibujos que borrar',
            drawingsCleared: '{{count}} dibujo(s) borrados · Deshacer: Cmd+Z',
            pasted: 'Pegado',
            enableOrientation: 'Activa primero la orientación de jugadores (Inspector → Orientación)',
            orientationModeOn: 'Modo de orientación de jugadores: ACTIVADO',
            orientationModeOff: 'Modo de orientación de jugadores: DESACTIVADO',
            visionAllOn: 'Visión: ACTIVADA — {{count}} jugador(es)',
            visionAllOff: 'Visión: DESACTIVADA — {{count}} jugador(es)',
            noPlayersOnBoard: 'No hay jugadores en el campo',
            visionSelected: 'Visión alternada para {{count}} jugador(es)',
            visionSelectedOn: 'Visión activada para {{count}} jugador(es)',
            selectPlayersForVision: 'Selecciona jugadores para alternar la visión',
            groupCreated: 'Grupo creado',
            goalkeeperSet: 'Portero de {{team}} asignado',
            goalkeeperColor: 'Color GK {{team}}: {{color}}',
            gridHidden: 'Cuadrícula oculta',
            gridVisible: 'Cuadrícula visible',
            snapEnabled: 'Ajuste activado',
            snapDisabled: 'Ajuste desactivado',
            passArrowAutoNumber: 'Flecha de pase (autonúmero)',
            runArrowAutoNumber: 'Flecha de carrera (autonúmero)',
            zoneShapeChanged: 'Forma de zona cambiada',
            savedCloud: 'Guardado en la nube',
            cloudSaveFailed: 'Error al guardar en la nube',
            savedLocal: 'Guardado localmente',
            shapeChanged: 'Forma cambiada',
            portraitMode: 'Modo vertical (75%)',
            landscapeMode: 'Modo horizontal',
            printModeOff: 'Modo impresión DESACTIVADO',
            printModeOn: 'Modo impresión ACTIVADO',
            stepAdded: 'Nuevo paso añadido',
            stepDeleted: 'Paso eliminado',
            stepLimitFree: 'Tienes {{count}}/10 pasos. Mejora a Pro para pasos ilimitados.',
            loopOn: 'Bucle activado',
            loopOff: 'Bucle desactivado',
            autoNumberingOn: 'Autonumeración ACTIVADA',
            autoNumberingOff: 'Autonumeración DESACTIVADA',
            background: 'Fondo: {{color}}',
            backgroundRemoved: 'Fondo eliminado',
            signInToSave: 'Inicia sesión para guardar proyectos — es gratis',
            fontSize: 'Tamaño de fuente: {{size}}px',
            previousColor: 'Color anterior',
            nextColor: 'Color siguiente',
            normal: 'Normal',
            bold: 'Negrita',
            italic: 'Cursiva',
            thinnerStroke: 'Trazo más fino',
            thickerStroke: 'Trazo más grueso',
            alignPrev: 'Alineación anterior',
            alignNext: 'Siguiente alineación',
            arrowNumberToggled: 'Número de flecha alternado',
            resizedUp: 'Redimensionado +10%',
            resizedDown: 'Redimensionado -10%',
            resizedTo: 'Redimensionado a {{percent}}%',
            layerControlSoon: 'Control de capas próximamente',
            playerAdded: 'Jugador añadido',
            ballAdded: 'Balón añadido',
            arrowAdded: 'Flecha añadida',
            zoneAdded: 'Zona añadida',
            colorChanged: 'Color cambiado',
            switchedTeam: 'Cambiado a {{team}}',
            playerColorChanged: 'Color de jugador cambiado (usa Alt+↓/↑ para alternar)',
            textColorChanged: 'Color de texto cambiado (usa Alt+↓/↑ para alternar)',
            equipmentUp: 'Equipamiento +15%',
            equipmentDown: 'Equipamiento -15%',
            orientationReset: 'Orientación del jugador restablecida',
            playerOrientation: 'Orientación del jugador {{delta}}°',
            rotatedLeft15: 'Girado -15°',
            rotatedRight15: 'Girado +15°',
            rotatedLeft90: 'Girado -90°',
            rotatedRight90: 'Girado +90°',
            formationApplied: '{{formation}} aplicado ({{team}})',
            lineupApplied: 'Alineación guardada {{slot}} aplicada',
            lineupEmpty: 'La posición de alineación {{slot}} está vacía',
        },
    },
    shortcuts: {
        'add-home-player': 'Añadir jugador local',
        'add-away-player': 'Añadir jugador visitante',
        'add-team3-player': 'Añadir jugador equipo 3',
        'add-team4-player': 'Añadir jugador equipo 4',
        'add-ball': 'Añadir balón',
        'pass-arrow': 'Flecha de pase',
        'run-arrow': 'Flecha de desmarque',
        'shot-arrow': 'Flecha de tiro',
        'dribble-arrow': 'Flecha de regate',
        'rect-zone': 'Zona rectangular',
        'ellipse-zone': 'Zona elipse',
        'text-label': 'Etiqueta de texto',
        'freehand-draw': 'Dibujo a mano alzada',
        'highlighter': 'Resaltador',
        'clear-drawings': 'Borrar dibujos',
        'goal': 'Portería (Shift mini)',
        'mannequin': 'Maniquí (Shift plano)',
        'cone': 'Cono (Shift alto)',
        'ladder': 'Escalera',
        'hoop': 'Aro',
        'hurdle': 'Valla',
        'rotate-minus': 'Rotar -15°',
        'rotate-plus': 'Rotar +15°',
        'rotate-minus-90': 'Rotar -90°',
        'rotate-plus-90': 'Rotar +90°',
        'undo': 'Deshacer',
        'redo': 'Rehacer',
        'copy': 'Copiar',
        'paste': 'Pegar',
        'duplicate': 'Duplicar',
        'delete': 'Eliminar',
        'deselect': 'Deseleccionar todo',
        'select-all': 'Seleccionar todo',
        'cycle-player-shape': 'Cambiar forma de jugador',
        'cycle-zone-shape': 'Cambiar forma de zona',
        'group-selection': 'Agrupar selección',
        'ungroup-selection': 'Desagrupar',
        'lock-unlock': 'Bloquear / Desbloquear',
        'quick-edit-number': 'Edición rápida de número',
        'cycle-color': 'Cambiar color',
        'stroke-width': 'Grosor de línea',
        'focus-mode': 'Modo enfoque',
        'toggle-inspector': 'Alternar inspector',
        'player-orientation': 'Orientación del jugador',
        'print-mode': 'Modo impresión',
        'cycle-pitch-view': 'Cambiar vista del campo',
        'all-shortcuts': 'Todos los atajos',
        'command-palette': 'Paleta de comandos',
        'toggle-orientation': 'Alternar orientación',
        'toggle-orientation-mode': 'Alternar modo orientación',
        'open-projects': 'Abrir proyectos',
        'zoom-in': 'Acercar',
        'zoom-out': 'Alejar',
        'toggle-shortcuts': 'Alternar atajos',
        'prev-next-step': 'Paso ant./sig.',
        'play-pause': 'Reproducir/Pausa',
        'new-step': 'Nuevo paso',
        'delete-step': 'Eliminar paso',
        'add-step': 'Añadir paso',
        'toggle-loop': 'Alternar bucle',
        'export-png': 'Exportar PNG',
        'export-all-png': 'Exportar todos los PNG',
        'export-gif': 'Exportar GIF',
        'export-pdf': 'Exportar PDF',
        'home-formation': 'Aplicar formación local',
        'away-formation': 'Aplicar formación visitante',
        'set-gk': 'Establecer portero / color GK',
        'pass-num': 'Pase + número',
        'run-num': 'Desmarque + número',
        'toggle-auto-num': 'Alternar auto-numeración',
        'toggle-number': 'Alternar número',
    },
    appToast: {
        clubCreated: 'Club creado',
        upgradeSuccessful: 'Mejora completada.',
        subscriptionActivating: 'Tu suscripción se está activando. Actualiza en un momento.',
        subscriptionFree: 'Suscripción actualizada — ahora estás en Free.',
        subscriptionPro: 'Suscripción actualizada — Pro está activo.',
        subscriptionTeam: 'Suscripción actualizada — Team está activo.',
        billingUpdated: 'Facturación actualizada.',
        checkoutCancelled: 'Checkout cancelado',
        welcomeBack: 'Bienvenido de nuevo.',
        googleLoginStarted: 'Google se abrió en una ventana separada.',
        googleLoginFailed: 'No se pudo iniciar sesión con Google. Inténtalo de nuevo.',
        devLogin: 'Sesión iniciada como usuario de prueba {{tier}}',
    },
    storeToast: {
        toolActive: 'Herramienta {{tool}} activa — haz clic para colocar • Esc para salir',
        zoom: 'Zoom: {{percent}}%',
        zoomFit: 'Zoom: ajustar',
        backOnline: 'Vuelves a estar online',
        offline: 'Estás offline',
        saveFailedRetry: 'Error al guardar — se reintentará al volver online',
        saveGuestTitle: '¿Guardar tu trabajo?',
        saveGuestDescription: 'Tienes trabajo sin guardar de tu sesión de invitado. ¿Quieres guardarlo en tu cuenta en la nube?',
        saveGuestConfirm: 'Guardar en la nube',
        discard: 'Descartar',
        guestWorkSaved: 'Tu trabajo se guardó en la nube.',
        guestWorkSaveFailed: 'No se pudo guardar. Prueba a guardar manualmente con Cmd+S.',
        tools: {
            'player-home': 'Jugador local',
            'player-away': 'Jugador visitante',
            ball: 'Balón',
            'arrow-pass': 'Flecha de pase',
            'arrow-run': 'Flecha de carrera',
            'arrow-shoot': 'Flecha de tiro',
            'arrow-dribble': 'Flecha de regate',
            zone: 'Zona',
            'zone-ellipse': 'Zona elíptica',
            'zone-polygon': 'Zona poligonal — haz clic para añadir puntos, doble clic para terminar',
            text: 'Texto',
        },
    },
    legal: {
        draftBanner: '⚠ Este es un borrador — pendiente de revisión legal.',
        updated: 'Última actualización: {{date}}',
        back: 'Volver a TMC Studio',
        privacy: {
            title: 'Política de privacidad',
            intro: {
                title: '1. Introducción',
                body: 'TMC Studio ("nosotros", "nuestro" o "nos") se compromete a proteger tu privacidad. Esta Política de privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando utilizas nuestra aplicación de pizarra táctica.',
            },
            collect: {
                title: '2. Información que recopilamos',
                providedTitle: '2.1 Información que proporcionas',
                automaticTitle: '2.2 Información recopilada automáticamente',
                provided: {
                    account: 'Información de cuenta (email, nombre)',
                    project: 'Datos de proyectos (pizarras tácticas, formaciones, anotaciones)',
                    payment: 'Información de pago (procesada de forma segura por Stripe)',
                },
                automatic: {
                    usage: 'Datos de uso y analítica',
                    device: 'Información del dispositivo y del navegador',
                    location: 'Dirección IP y datos de ubicación',
                },
            },
            use: {
                title: '3. Cómo usamos tu información',
                items: {
                    maintain: 'Proporcionar y mantener nuestro servicio',
                    payments: 'Procesar tus pagos y suscripciones',
                    updates: 'Enviarte actualizaciones y notificaciones',
                    improve: 'Mejorar nuestra aplicación y la experiencia de usuario',
                    legal: 'Cumplir obligaciones legales',
                },
            },
            storage: {
                title: '4. Almacenamiento y seguridad de datos',
                body: 'Tus datos se almacenan de forma segura con Supabase (base de datos PostgreSQL), con cifrado en reposo y en tránsito. Implementamos medidas de seguridad estándar del sector para proteger tu información.',
            },
            sharing: {
                title: '5. Compartición de datos',
                body: 'No vendemos tu información personal. Podemos compartir tus datos con:',
                stripe: 'para el procesamiento de pagos',
                supabase: 'para alojamiento de datos y autenticación',
                netlify: 'para el alojamiento de la aplicación',
                sentry: 'para la supervisión de errores (informes técnicos de errores, sin el contenido de tus pizarras)',
                postmark: 'para enviar correos transaccionales (invitaciones al club, respuestas a informes de errores)',
                google: 'para iniciar sesión con una cuenta de Google, si la eliges',
                plausible: 'para estadísticas de uso respetuosas con la privacidad, solo con tu consentimiento de analítica',
            },
            rights: {
                title: '6. Tus derechos',
                body: 'Tienes derecho a:',
                items: {
                    access: 'Acceder a tus datos personales',
                    correct: 'Corregir datos inexactos',
                    delete: 'Solicitar la eliminación de tus datos',
                    export: 'Exportar tus datos',
                    optOut: 'Oponerte a comunicaciones de marketing',
                },
            },
            cookies: {
                title: '7. Cookies',
                before: 'Usamos cookies esenciales para autenticación y almacenamiento de preferencias. Puedes controlar las cookies desde la configuración de tu navegador. Consulta nuestra',
                link: 'Política de cookies',
                after: 'para más detalles.',
            },
            children: {
                title: '8. Privacidad de menores',
                body: 'Nuestro servicio no está destinado a menores de 13 años. No recopilamos conscientemente información personal de menores.',
            },
            changes: {
                title: '9. Cambios en esta política',
                body: 'Podemos actualizar esta Política de privacidad de vez en cuando. Te notificaremos los cambios publicando la nueva política en esta página y actualizando la fecha de "Última actualización".',
            },
            contact: {
                title: '10. Contacto',
                body: 'Si tienes preguntas sobre esta Política de privacidad, contáctanos en:',
            },
        },
        terms: {
            title: 'Términos del servicio',
            acceptance: {
                title: '1. Aceptación de los términos',
                body: 'Al acceder y utilizar TMC Studio ("Servicio"), aceptas y te comprometes a cumplir los términos y disposiciones de este acuerdo. Si no aceptas estos Términos del servicio, no utilices nuestro Servicio.',
            },
            description: {
                title: '2. Descripción del servicio',
                body: 'TMC Studio es una aplicación web de pizarra táctica para entrenadores y analistas deportivos. El Servicio permite crear, editar y compartir diagramas tácticos, formaciones y secuencias animadas.',
            },
            accounts: {
                title: '3. Cuentas de usuario',
                registrationTitle: '3.1 Registro',
                registration: 'Para acceder a ciertas funciones, debes crear una cuenta. Aceptas proporcionar información precisa, actual y completa durante el registro.',
                securityTitle: '3.2 Seguridad de la cuenta',
                security: 'Eres responsable de mantener la confidencialidad de tus credenciales. Aceptas notificarnos inmediatamente cualquier uso no autorizado de tu cuenta.',
                terminationTitle: '3.3 Terminación de la cuenta',
                termination: 'Nos reservamos el derecho de suspender o terminar tu cuenta si incumples estos Términos o realizas actividades fraudulentas o ilegales.',
            },
            payments: {
                title: '4. Suscripciones y pagos',
                pricingTitle: '4.1 Precios',
                pricing: 'Ofrecemos planes de suscripción gratuitos y de pago. Los precios se muestran en nuestro sitio web y pueden cambiar con 30 días de aviso.',
                billingTitle: '4.2 Facturación',
                billing: 'Las suscripciones de pago se facturan mensual o anualmente por adelantado. Los pagos se procesan de forma segura mediante Stripe.',
                refundsTitle: '4.3 Reembolsos',
                refunds: 'Las solicitudes de reembolso se gestionan caso por caso. Contacta con soporte si crees que tienes derecho a un reembolso.',
                cancellationTitle: '4.4 Cancelación',
                cancellation: 'Puedes cancelar tu suscripción en cualquier momento. Las cancelaciones surten efecto al final del periodo de facturación actual.',
            },
            content: {
                title: '5. Contenido de usuario',
                ownershipTitle: '5.1 Propiedad',
                ownership: 'Conservas todos los derechos sobre las pizarras tácticas y el contenido que creas usando nuestro Servicio. No reclamamos propiedad sobre tu contenido de usuario.',
                licenseTitle: '5.2 Licencia',
                license: 'Al usar nuestro Servicio, nos otorgas una licencia limitada para alojar, almacenar y mostrar tu contenido únicamente con el fin de prestarte el Servicio.',
                prohibitedTitle: '5.3 Contenido prohibido',
                prohibitedIntro: 'Aceptas no subir ni compartir contenido que:',
                prohibited: {
                    laws: 'Infrinja leyes o regulaciones',
                    ip: 'Vulnere derechos de propiedad intelectual',
                    malware: 'Contenga malware o código dañino',
                    offensive: 'Sea ofensivo, acosador o discriminatorio',
                },
            },
            acceptable: {
                title: '6. Uso aceptable',
                intro: 'Aceptas no:',
                items: {
                    reverse: 'Realizar ingeniería inversa o intentar extraer código fuente',
                    automated: 'Usar herramientas automatizadas para acceder al Servicio (bots, scrapers)',
                    disrupt: 'Interferir con el Servicio o interrumpirlo',
                    share: 'Compartir tu cuenta con otras personas',
                    illegal: 'Usar el Servicio con cualquier propósito ilegal',
                },
            },
            ip: {
                title: '7. Propiedad intelectual',
                body: 'El Servicio, incluido su software, diseño, gráficos y contenido (excluido el contenido de usuario), es propiedad de TMC Studio y está protegido por derechos de autor, marcas comerciales y otras leyes de propiedad intelectual.',
            },
            disclaimers: {
                title: '8. Descargos de responsabilidad',
                body: 'EL SERVICIO SE PROPORCIONA "TAL CUAL", SIN GARANTÍAS DE NINGÚN TIPO. No garantizamos que el Servicio sea ininterrumpido, seguro o libre de errores.',
            },
            liability: {
                title: '9. Limitación de responsabilidad',
                body: 'EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, TMC Studio no será responsable de daños indirectos, incidentales, especiales o consecuentes derivados de tu uso del Servicio.',
            },
            backup: {
                title: '10. Copia de seguridad de datos',
                body: 'Aunque implementamos procedimientos de copia de seguridad, eres responsable de mantener tus propias copias de tu contenido. No somos responsables de la pérdida de datos.',
            },
            changes: {
                title: '11. Cambios en los términos',
                body: 'Nos reservamos el derecho de modificar estos Términos en cualquier momento. Notificaremos a los usuarios los cambios importantes por email o notificación dentro de la aplicación. El uso continuado del Servicio constituye aceptación de los Términos modificados.',
            },
            law: {
                title: '12. Ley aplicable',
                body: 'Estos Términos se regirán e interpretarán de acuerdo con las leyes de Polonia, sin tener en cuenta sus disposiciones sobre conflictos de leyes.',
            },
            contact: {
                title: '13. Información de contacto',
                body: 'Si tienes preguntas sobre estos Términos, contáctanos en:',
            },
        },
        cookies: {
            title: 'Política de cookies',
            what: {
                title: '1. ¿Qué son las cookies?',
                body: 'Las cookies son pequeños archivos de texto que se colocan en tu dispositivo cuando visitas nuestro sitio web. Nos ayudan a ofrecerte una mejor experiencia recordando tus preferencias y entendiendo cómo usas nuestro Servicio.',
            },
            use: {
                title: '2. Cómo usamos las cookies',
                body: 'TMC Studio usa cookies para los siguientes fines:',
            },
            types: {
                title: '3. Tipos de cookies que usamos',
                essentialTitle: '3.1 Cookies esenciales',
                essentialBody: 'Estas cookies son necesarias para que el Servicio funcione correctamente. No se pueden desactivar.',
                essential: {
                    authentication: { label: 'Autenticación', body: 'Mantiene tu sesión iniciada en la cuenta' },
                    session: { label: 'Gestión de sesión', body: 'Mantiene tu sesión mientras usas la app' },
                    security: { label: 'Seguridad', body: 'Protege contra ataques CSRF y garantiza comunicación segura' },
                },
                preferenceTitle: '3.2 Cookies de preferencias',
                preferenceBody: 'Estas cookies recuerdan tus ajustes y preferencias:',
                preference: {
                    theme: { label: 'Tema', body: 'Recuerda tu preferencia de modo oscuro/claro' },
                    language: { label: 'Idioma', body: 'Guarda tu selección de idioma' },
                    ui: { label: 'Ajustes de UI', body: 'Guarda el estado del panel inspector, el nivel de zoom, etc.' },
                },
                analyticsTitle: '3.3 Cookies analíticas (opcionales)',
                analyticsBody: 'Estas cookies nos ayudan a entender cómo los visitantes usan nuestro Servicio:',
                analytics: {
                    usage: { label: 'Patrones de uso', body: 'Qué funciones son más populares' },
                    performance: { label: 'Rendimiento', body: 'Qué tan rápido cargan las páginas' },
                    errors: { label: 'Seguimiento de errores', body: 'Identifica problemas técnicos' },
                },
                analyticsNote: 'Con tu consentimiento, usamos Plausible, una analítica centrada en la privacidad, para medir el uso del producto y los errores. No creamos perfiles publicitarios.',
            },
            thirdParty: {
                title: '4. Cookies de terceros',
                body: 'Usamos los siguientes servicios de terceros que pueden establecer cookies:',
                supabase: 'para autenticación y almacenamiento de datos',
                stripe: 'para procesamiento seguro de pagos',
                policies: 'Estos servicios tienen sus propias políticas de privacidad y cookies:',
                supabasePolicy: 'Política de privacidad de Supabase',
                stripePolicy: 'Política de privacidad de Stripe',
            },
            localStorage: {
                title: '5. Almacenamiento local',
                body: 'Además de las cookies, usamos el almacenamiento local del navegador para:',
                items: {
                    cache: 'Guardar en caché tus pizarras tácticas para acceso offline',
                    state: 'Guardar el estado de la aplicación entre sesiones',
                    project: 'Recordar tu último proyecto editado',
                },
            },
            manage: {
                title: '6. Gestión de cookies',
                browserTitle: '6.1 Controles del navegador',
                browserBody: 'La mayoría de navegadores permite controlar cookies desde sus ajustes. Puedes:',
                browser: {
                    blockAll: 'Bloquear todas las cookies',
                    blockThirdParty: 'Bloquear solo cookies de terceros',
                    deleteSession: 'Eliminar cookies después de cada sesión',
                    viewDelete: 'Ver y eliminar cookies específicas',
                },
                impactTitle: '6.2 Impacto de bloquear cookies',
                important: 'Importante:',
                impactBody: 'Si bloqueas cookies esenciales, no podrás iniciar sesión ni usar funciones en la nube. Las cookies de preferencias pueden bloquearse con un impacto mínimo en la funcionalidad.',
                changeConsent: 'Cambiar el consentimiento de analítica',
            },
            duration: {
                title: '7. Duración de las cookies',
                sessionTitle: 'Cookies de sesión',
                sessionBody: 'Se eliminan cuando cierras el navegador',
                persistentTitle: 'Cookies persistentes',
                persistentBody: 'Permanecen hasta 1 año o hasta que las elimines',
            },
            updates: {
                title: '8. Actualizaciones de esta política',
                body: 'Podemos actualizar esta Política de cookies de vez en cuando. Te notificaremos cualquier cambio importante actualizando la fecha de "Última actualización" en la parte superior de esta página.',
            },
            contact: {
                title: '9. Contacto',
                body: 'Si tienes preguntas sobre nuestro uso de cookies, contáctanos en:',
            },
        },
        refunds: {
            title: 'Reembolsos y cancelación',
            intro: 'Esta página explica la cancelación, el derecho de desistimiento y el soporte de pagos para las suscripciones de TMC Studio.',
            withdrawalTitle: 'Derecho de desistimiento',
            withdrawalBody: 'Si contratas como consumidor en la Unión Europea, puedes tener un derecho de desistimiento de 14 días salvo que aceptes que el servicio digital comience antes de que finalice ese plazo.',
            waiverTitle: 'Inicio del servicio digital',
            waiverBody: 'Las funciones de pago pueden activarse inmediatamente después de la compra. En ese caso, según la legislación aplicable, el derecho de desistimiento puede expirar cuando el servicio comience con tu consentimiento.',
            cancelTitle: 'Cancelar una suscripción',
            cancelBody: 'Puedes cancelar tu suscripción en cualquier momento desde la configuración de cuenta y facturación. El acceso de pago permanece activo hasta el final del periodo ya abonado.',
            refundTitle: 'Reembolsos',
            refundBody: 'Los reembolsos se revisan caso por caso, especialmente ante cargos incorrectos, problemas técnicos o pagos duplicados. Los pagos son procesados por Stripe.',
            contactTitle: 'Soporte de pagos',
            contactBody: 'Contáctanos si necesitas ayuda con cancelaciones, facturas o reembolsos:',
        },
        legalNotice: {
            title: 'Aviso legal',
            intro: 'Información sobre la entidad responsable de TMC Studio y datos oficiales de contacto.',
            providerTitle: 'Proveedor del servicio',
            registeredAt: 'Fecha de registro: {{date}}',
            contactTitle: 'Contacto',
            contactBody: 'Para asuntos legales y formales, contáctanos en:',
            vatTitle: 'Identificación fiscal',
            vatBody: 'NIP/ID fiscal: {{nip}}. Los pagos online son procesados por Stripe.',
            responsibleTitle: 'Responsabilidad sobre contenidos',
            responsibleBody: 'Trabajamos para mantener la información del servicio precisa y actualizada. El contenido creado por usuarios sigue siendo responsabilidad de sus autores.',
        },
        accessibility: {
            title: 'Accesibilidad',
            commitmentTitle: 'Nuestro compromiso',
            commitmentBody: 'Queremos que TMC Studio sea lo más accesible posible para entrenadores, analistas y creadores que utilizan distintos dispositivos y tecnologías de asistencia.',
            statusTitle: 'Estado actual',
            statusBody: 'La aplicación está en desarrollo activo. Estamos mejorando la legibilidad de la interfaz, el soporte de teclado, el contraste y la estabilidad del diseño en pantallas pequeñas.',
            feedbackTitle: 'Comentarios',
            feedbackBody: 'Si detectas una barrera de accesibilidad o algo que dificulte el uso de la aplicación, contáctanos:',
        },
    },
    organizationPanel: {
        title: 'Club',
        seats: 'Plazas usadas: {{used}} / {{max}}',
        upsell: {
            description: 'Invita a entrenadores y personal a tu club actualizando al plan Team.',
            cta: 'Actualizar a Team',
        },
        intro: {
            title: 'Cómo funciona',
            step1: '1. Crea tu club y dale un nombre.',
            step2: '2. Crea un enlace de invitación seguro y compártelo con tu personal.',
            step3: '3. Cada miembro tiene acceso a los proyectos compartidos del club.',
        },
        create: {
            description: 'Crea tu club para invitar a entrenadores y personal.',
            nameLabel: 'Nombre del club',
            namePlaceholder: 'p. ej. Academia Juvenil FC Ejemplo',
            cta: 'Crear club',
            creating: 'Creando…',
        },
        members: {
            title: 'Miembros',
            remove: 'Eliminar',
            leave: 'Abandonar club',
            leaving: 'Abandonando…',
            transferOwnership: 'Transferir propiedad',
            transferSelect: 'Elige un nuevo propietario…',
            transferConfirm: 'Transferir',
            transferring: 'Transfiriendo…',
            cancel: 'Cancelar',
            deleteClub: 'Eliminar club',
            deleteClubConfirm: '¿Eliminar este club de forma permanente? Esta acción no se puede deshacer.',
            deleteClubConfirmCta: 'Sí, eliminar',
            deleting: 'Eliminando…',
        },
        invite: {
            title: 'Invitar',
            emailPlaceholder: 'entrenador@ejemplo.com',
            cta: 'Enviar invitación',
            sending: 'Enviando…',
            pending: 'Invitaciones pendientes',
            copyLink: 'Copiar enlace',
            linkCopied: '¡Enlace copiado!',
            revoke: 'Revocar',
            seatLimitReached: 'Has alcanzado el límite de plazas del plan Team. Elimina un miembro o mejora tu plan para invitar a más personas.',
            shareHint: 'TMC Studio envía una invitación segura por correo. También puedes copiar el enlace de las invitaciones pendientes.',
            sent: 'Invitación enviada a {{email}}.',
        },
        roles: {
            owner: 'Propietario',
            member: 'Miembro',
        },
        memberAccess: {
            title: 'Eres miembro de {{club}}',
            description: 'Tienes acceso a los proyectos y recursos compartidos de este club.',
        },
        errors: {
            createFailed: 'No se pudo crear el club. Inténtalo de nuevo.',
            inviteFailed: 'No se pudo enviar la invitación. Inténtalo de nuevo.',
            invalidRequest: 'La solicitud de invitación no es válida.',
            invalidEmail: 'Introduce una dirección de correo válida.',
            notAuthorized: 'Solo el propietario del club puede enviar invitaciones.',
            notAuthenticated: 'Vuelve a iniciar sesión antes de enviar una invitación.',
            teamRequired: 'Se necesita un plan Team activo para invitar miembros.',
            seatLimitReached: 'Se ha alcanzado el límite de plazas del plan Team.',
            alreadyMember: 'Esta persona ya es miembro del club.',
            alreadyPending: 'Ya hay una invitación pendiente para este correo.',
            deliveryFailed: 'No se pudo entregar el correo. No se creó ninguna invitación pendiente.',
            configurationError: 'El correo de invitación no está disponible temporalmente.',
            rateLimited: 'Se enviaron demasiadas invitaciones. Espera un minuto e inténtalo de nuevo.',
            transferFailed: 'No se pudo transferir la propiedad del club. Inténtalo de nuevo.',
            deleteFailed: 'No se pudo eliminar el club. Inténtalo de nuevo.',
            leaveFailed: 'No se pudo abandonar el club. Inténtalo de nuevo.',
        },
        welcome: {
            title: '¡Bienvenido a Club Premium!',
            subtitle: 'Configura tu club en 3 pasos rápidos',
            nameTeamLabel: 'Nombra tu club',
            nameTeamPlaceholder: 'ej. FC Ejemplo Cantera Activa',
            continue: 'Continuar',
            skip: 'Lo haré después',
            inviteTitle: 'Invita a tu primer miembro',
            inviteDescription: 'Abre el panel de Equipo para invitar a entrenadores y staff a tu club.',
            teamPanelHint: 'Abrir panel de Equipo en el Inspector',
            teamPanelDesc: 'Añade miembros por email — obtienen acceso instantáneo a Club Premium',
            openTeamPanel: 'Abrir panel de Equipo',
            doLater: 'Invitaré después',
            completeTitle: '¡Todo listo!',
            completeDescription: 'Tu club está listo. Esto es lo que puedes hacer ahora:',
            benefitUnlimited: 'Proyectos y pasos ilimitados',
            benefitExport: 'Exportación GIF, PDF y más',
            benefitMembers: 'Gestiona hasta 5 miembros del equipo',
            startCoaching: 'Empezar a entrenar',
        },
    },
    invitePage: {
        loading: 'Cargando invitación…',
        goToApp: 'Ir a TMC Studio',
        notFound: {
            title: 'Invitación no encontrada',
            description: 'Este enlace de invitación no es válido. Pide al administrador del club que envíe uno nuevo.',
        },
        expired: {
            title: 'La invitación ya no es válida',
            description: 'Esta invitación ha caducado o ha sido revocada. Pide al administrador del club que envíe una nueva.',
        },
        declined: {
            title: 'Invitación rechazada',
            description: 'Has rechazado la invitación a {{club}}. El administrador del club puede enviarte una nueva si cambias de opinión.',
        },
        accepted: {
            title: '¡Ya eres parte del club!',
            description: 'Te has unido a {{club}}.',
        },
        ready: {
            title: 'Has sido invitado',
            description: 'Has sido invitado a unirte a {{club}} como {{role}} ({{email}}).',
            signInPrompt: 'Inicia sesión o crea una cuenta con {{email}} para aceptar esta invitación.',
            signIn: 'Iniciar sesión',
            wrongAccount: 'Esta invitación se envió a {{invited}}, pero has iniciado sesión como {{current}}. Inicia sesión con el correo invitado.',
            accept: 'Aceptar invitación',
            accepting: 'Uniéndote…',
            decline: 'Rechazar invitación',
            declining: 'Rechazando…',
        },
        errors: {
            acceptFailed: 'No se pudo aceptar la invitación. Inténtalo de nuevo.',
            declineFailed: 'No se pudo rechazar la invitación. Inténtalo de nuevo.',
        },
    },
    languages: {
        pl: 'Polski',
        en: 'English',
        es: 'Español',
    },
    pageNotFound: {
        title: 'Página no encontrada',
        description: 'Esta dirección no existe o se ha movido.',
        cta: 'Abrir la pizarra',
    },
};
//# sourceMappingURL=es.js.map